export const frTranslations = {
  // Events POC — local demo account switcher
  demo: {
    title: "Mode démo",
    subtitle: "Changez de compte en un clic pour tester le POC Événements. Disponible uniquement en local.",
    disabled: "Le mode démo n’est pas activé.",
    switching: "Changement de compte…",
    note: "Comptes fictifs créés par le script de démo de l’API. Cette page n’existe pas en production.",
    personas: {
      visitor: {
        name: "Visiteur",
        description: "Non connecté : ce que voit quelqu’un qui scanne le QR code.",
      },
      attendee: {
        name: "Alice, participante",
        description: "Inscrite aux deux événements de démo.",
      },
      orga: {
        name: "Olivia, organisatrice",
        description: "Crée et gère les événements.",
      },
      admin: {
        name: "Admin KeepTouch, super-admin",
        description: "Valide les organisateurs et règle leur commission.",
      },
    },
    shortcuts: {
      title: "Raccourcis",
      qr: "Page d’un événement vue du QR code (visiteur)",
      ended: "Événement terminé, profils complets (Alice)",
      dashboard: "Espace organisateur (Olivia)",
      create: "Créer un événement (Olivia)",
      admin: "Administration : demandes d'organisateurs (Admin KeepTouch)",
    },
  },
  errorBoundary: {
    title: 'Oups, une erreur est survenue',
    message: "Un problème inattendu s'est produit. Vous pouvez réessayer.",
  },
  api: {
    'ContactRequest.AlreadyExists':
      'Vous avez déjà envoyé une demande de contact à cet utilisateur',
    'Global.OperationNotAllowedError': "Vous n'êtes pas autorisé à effectuer cette opération",
    'Global.ResourceDeletionNotAllowedError':
      "Vous n'êtes pas autorisé à supprimer cette ressource",
    'Global.ResourceNotFoundError': "La ressource n'a pas été trouvée",
    'IdentityAndAccess.InvalidCredentialsError': "L'email ou le mot de passe n'est pas bon",
    'IdentityAndAccess.EmailAlreadyTakenError': "L'email est déjà pris",
    'Networking.CannotCancelNonPendingContactRequestError':
      "Vous ne pouvez pas annuler une demande de contact qui n'est pas en attente",
    'Networking.OnboardingAlreadyCompleteError':
      "Vous avez déjà complété le processus d'onboarding",
    'Networking.GhostProfileNoEmailError':
      "Ce profil n'a pas d'adresse e-mail. Ajoutez une adresse e-mail pour envoyer une invitation.",
    'Notifications.DeviceAlreadyRegisteredError': 'Le device est déjà enregistré',
    NetworkError: 'Erreur réseau. Veuillez vérifier votre connexion internet.',
  },
  tabNavigation: {
    home: 'Accueil',
    contacts: 'Contacts',
    messages: 'Messages',
    notifications: 'Notifications',
    chatbot: 'Assistant IA',
    profile: 'Menu',
  },
  chatbot: {
    title: 'Assistant IA',
    placeholder: 'Posez-moi une question...',
    thinking: 'Réflexion en cours...',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    welcome:
      'Bonjour ! Je suis votre assistant IA. Je peux vous aider à gérer vos contacts, notes, catégories et hashtags. Comment puis-je vous aider ?',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    actionConfirmed: 'Action confirmée.',
    actionCancelled: 'Action annulée.',
    history: 'Historique',
    historyEmpty: 'Aucune conversation enregistrée.',
    untitled: 'Conversation sans titre',
    deleteConversationTitle: 'Supprimer cette conversation ?',
    deleteConversationError: "La conversation n'a pas pu être supprimée. Veuillez réessayer.",
    suggestionsTitle: 'Voici quelques exemples :',
    suggestions: {
      notes: 'Cherche dans toutes mes notes',
      conversations: 'Résume ma dernière conversation LinkedIn',
      sector: 'Qui travaille dans la cybersécurité ?',
      calendar: 'Quels sont mes prochains rendez-vous ?',
      findContact: 'Aide-moi à retrouver un contact',
    },
    actions: {
      createNote: 'Créer la note « {name} »',
      updateNote: 'Modifier la note {name}',
      deleteNote: 'Supprimer la note {name}',
      createCategory: 'Créer la catégorie « {name} »',
      createHashtag: 'Créer le hashtag « {name} »',
      createGhostProfile: 'Créer la fiche de {name}',
      updateGhostProfile: 'Modifier la fiche de {name}',
      deleteGhostProfile: 'Supprimer la fiche de {name}',
    },
  },
  welcome: {
    title: 'KEEPTOUCH',
    tagline: 'Un seul contact peut changer toute une vie.',
    connection: 'Connexion',
    registration: 'Inscription',
    slogan: 'Gardez, gérez vos contacts de demain \n Trouvez et réalisez des projets communs',
    languageFr: 'Français',
    languageEn: 'English',
    languageEs: 'Español',
  },
  login: {
    title: 'Se connecter',
    brand: 'KeepTouch',
    tagline: 'Ne perdez plus le contact avec ceux qui comptent',
    email: 'Adresse mail',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    button: 'Connexion',
    noAccount: "Je n'ai pas de compte",
    or: 'Ou',
    error: {
      noInfo: 'Entrer vos informations',
      wrongCredentials: "L'email ou le mot de passe n'est pas bon",
      invalidEmail: "Cette adresse email n'est pas valide.",
    },
  },
  register: {
    title: "S'inscrire",
    email: 'Adresse mail',
    password: 'Mot de passe',
    confirmPassword: 'De nouveau mot de passe',
    button: 'Inscription',
    haveAccount: "J'ai déjà un compte",
    or: 'Ou',
    error: {
      noInfo: 'Entrer vos informations',
      notSamePassword: 'Les mots de passe ne correspondent pas',
    },
  },
  registerSteps: {
    step2: 'Tu es plutôt ? #',
    step3: 'Le meilleur moment pour te contacter ?',
    skip: 'Passer',
  },
  registerStep1: {
    title: {
      picture: 'Ajoute ta photo de profil :',
      gender: 'Tu es :',
      name: 'Ton prénom :',
      surname: 'Ton nom :',
      birthday: "Ta date d'anniversaire :",
      athletic: 'Est ce que tu es sportif :',
      info: 'A propos de toi :',
      languages: 'Quelles langues parles-tu :',
      nationality: 'De quelle nationalité es-tu :',
      origin: 'Quelle origine as-tu :',
      personality: 'Quel est ton caractère :',
      residence: 'Où habites-tu :',
      smoker: 'Est-ce que tu fumes :',
      conditions: "J'accepte les conditions",
      conditionsRead: 'Lire :',
    },
    value: {
      women: 'Une femme',
      man: 'Un homme',
      nonBinary: 'Non binaire',
      other: 'Autre',
      yes: 'Oui',
      no: 'Non',
      calm: 'Calme',
      active: 'Actif',
      talkative: 'Bavard',
    },
    next: 'Suivant',
  },
  registerStepHastags: {
    mainTitle: 'Ce qui te définit #',
    title: 'Quels sont les hashtags qui te correspondent',
    placeholder: '#sport',
    next: 'Suivant',
  },
  registerStep3: {
    mainTitle: 'Le meilleur moment pour te contacter ?',
    title: 'Sélectionne les moments où tu es le plus disponible',
    aperitif: 'Apéro',
    breakfast: 'Petit déj',
    coffee: 'Café',
    dinner: 'Dîner',
    lunch: 'Déjeuner',
    walk: 'Balade',
    video_call: 'Vidéoconf',
    phone_call: 'Téléphone',
    videoCall: 'Vidéoconf',
    phoneCall: 'Téléphone',
    weekend: 'Weekend',
    sport: 'Sport',
    event: 'Événement',
    next: 'Suivant',
  },
  registerStep4: {
    aperitif: 'Apéro',
    breakfast: 'Petit déj',
    coffee: 'Café',
    dinner: 'Dîner',
    lunch: 'Déjeuner',
    walk: 'Balade',
    videoCall: 'Vidéoconf',
    phoneCall: 'Téléphone',
    weekend: 'Weekend',
    sport: 'Sport',
    event: 'Événement',
    next: 'Suivant',
  },
  registerFinalStep: {
    congrats: 'Félicitations,\n{name} {surname},\n ton compte est créé',
    congratsNoName: 'Félicitations,\nton compte est créé',
    next: 'Suivant',
    geolocationText: 'Activer la géolocalisation pour une meilleure expérience utilisateur',
  },
  forgotPassword: {
    title: 'Réinitialiser mot de passe',
    email: 'Adresse mail',
    emailConfirm: 'Confirmer adresse mail',
    button: 'Envoyer un lien par mail',
    success:
      'Si un compte existe avec cette adresse mail, vous recevrez un lien de réinitialisation sous peu.',
    error: {
      noEmail: 'Veuillez entrer votre adresse mail.',
      generic: 'Une erreur est survenue. Veuillez réessayer plus tard.',
    },
  },
  resetPassword: {
    title: 'Définir un nouveau mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    button: 'Réinitialiser le mot de passe',
    success: 'Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter.',
    error: {
      noToken: 'Lien de réinitialisation invalide ou manquant. Veuillez en demander un nouveau.',
      passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères.',
      passwordMismatch: 'Les mots de passe ne correspondent pas.',
      generic: 'Le lien a peut-être expiré. Veuillez en demander un nouveau.',
    },
  },
  contact: {
    title: 'Contacts',
    searchPlaceholder: 'Rechercher un contact',
    commonContacts: '{nbr} contacts{newline} en commun',
    commonProjects: '{nbr} projets{newline} en commun',
    addButton: 'Ajouter',
    addTitle: 'Ajouter {name} à votre profil',
    commonTitleModal: 'Amis et projets en commun',
    filter: {
      search: 'Rechercher',
      category: {
        location: 'Lieux',
        origin: 'Origine',
        role: 'Fonction',
        degree: 'Degré',
        hashtag: '#',
      },
      location: {
        continent: 'Continent',
        country: 'Rechercher un pays',
        region: 'États / Region',
      },
      nonLocation: {
        origin: 'Rechercher une origine',
        role: 'Rechercher une fonction',
        hashtag: 'Rechercher par #',
      },
    },
    emptyReceivedRequest: 'Aucune demande reçue pour le moment',
    emptySentRequest: 'Aucune demande envoyée pour le moment',
    emptyContactPro: 'Aucun contact professionnel',
    emptyContactPrivate: 'Aucun contact privé',
  },
  addContact: {
    title: 'Rechercher un contact',
    commonContacts: '{nbr} contacts{newline} en commun',
    commonProjects: '{nbr} projets{newline} en commun',
    addButton: 'Ajouter',
    addTitle: 'Ajouter {name} à votre profil',
    commonTitleModal: 'Amis et projets en commun',
    filter: {
      search: 'Rechercher',
      category: {
        location: 'Lieux',
        origin: 'Origine',
        role: 'Fonction',
        degree: 'Degré',
        hashtag: '#',
      },
      location: {
        continent: 'Continent',
        country: 'Rechercher un pays',
        region: 'États / Region',
      },
      nonLocation: {
        origin: 'Rechercher une origine',
        role: 'Rechercher une fonction',
        hashtag: 'Rechercher par #',
      },
    },
    emptyData: 'Aucun contact suggéré',
    degree1: '1er',
    degree2: '2e',
    degree3: '3e',
  },
  requestContact: {
    received: 'Reçues',
    sended: 'Envoyées',
  },
  menu: {
    profileButton: 'Voir le profil',
    nonExistentProfile: 'Profil non existant',
    share: 'Partager',
    settings: 'Paramètres',
    signOut: 'Se déconnecter',
    version: 'Version {version}',
  },
  contactType: {
    PRIVATE: 'Privé',
    PROFESSIONAL: 'Pro',
    GROUP: 'Groupe',
    OTHERS: 'Autres',
    GHOST: 'Fantôme',
  },
  profile: {
    premiumTitle: 'Essayez Premium',
    mainMenus: {
      updateProfile: 'Modifier le profil',
      shareProfile: 'Partager le profil',
      calendar: 'Calendrier',
      memories: 'Souvenirs',
    },
    hashtags: {
      blocTitle: 'Compétences',
      learn: {
        title: 'Apprendre',
        placeholder: 'Rechercher tes objectifs...',
      },
      target: {
        title: 'Objectifs',
        placeholder: 'Construire une maison...',
      },
      hobby: {
        title: 'Loisirs',
        placeholder: 'Faire du karaté...',
      },
      skill: {
        title: 'Compétences',
        placeholder: 'Marketing...',
      },
      button: 'Sauvegarder',
    },
    contact: {
      email: {
        title: 'Email',
      },
      phoneNumber: {
        title: 'Numéro de téléphone',
      },
      website: {
        title: 'Site web',
      },
      fbProfile: {
        title: 'Profil Facebook',
      },
      instagramProfile: {
        title: 'Profil Instagram',
      },
      linkedinProfile: {
        title: 'Profil LinkedIn',
      },
      twitterProfile: {
        title: 'Profil Twitter',
      },
      availability: 'Disponibilités',
      contact: 'Coordonnées',
    },
    presentation: {
      title: 'Présentation',
    },
    question: {
      title: 'Question',
      button: 'Sauvegarder',
      nationalities: {
        title: 'Quelles sont tes nationalités :',
        placeholder: 'Rechercher une nationalité...',
      },
      origins: {
        title: 'Quelles sont tes origines :',
        placeholder: 'Rechercher une origine...',
      },
      languages: {
        title: 'Quelles langues parles-tu :',
        placeholder: 'Rechercher une langue...',
        modal: {
          title: 'Sélectionner un pays',
          search: {
            placeholder: 'Rechercher un pays...',
          },
        },
      },
      countries: {
        title: 'Quels pays as-tu visités :',
        placeholder: 'Rechercher un pays...',
      },
      addLanguage: {
        title: 'Ajouter une langue',
        button: 'Sauvegarder',
        language: {
          title: 'Langue',
          placeholder: 'Sélectionner une langue',
        },
        level: {
          title: 'Niveau',
          placeholder: 'Sélectionner votre niveau',
          beginner: 'Débutant',
          intermediate: 'Intermédiaire',
          advanced: 'Avancé',
          expert: 'Expert',
        },
      },
    },
    livingPlaces: {
      title: 'Lieux de vie',
      addLivingPlace: {
        title: 'Ajouter un lieu de vie',
        button: 'Sauvegarder',
        country: {
          title: 'Pays',
          placeholder: 'Sélectionner un pays',
        },
        from: {
          title: 'Depuis',
        },
        to: {
          title: "Jusqu'à",
        },
      },
    },
    updateSuccess: 'Profil mis à jour',
    about: {
      title: 'Apprendre plus',
      save: 'Sauvegarder',
      categories: {
        learn: {
          title: 'Que veux-tu apprendre ?',
          placeholder: 'Rechercher tes objectifs...',
        },
        objective: {
          title: 'Objectif',
          placeholder: '#construire une maison...',
        },
        hobby: {
          title: 'Hobby',
          placeholder: '# faire du karate...',
        },
        skills: {
          title: 'Compétences',
          placeholder: '# Marketing...',
        },
      },
    },
  },
  search: {
    placeholder: 'Rechercher',
    noResults: 'Aucun résultat',
  },
  imageUpload: {
    fromCamera: 'Prendre une photo',
    fromGallery: 'Importer depuis le téléphone',
    cropTitle: 'Recadrer la photo',
    cropHint: 'Faites glisser la photo et réglez la taille comme vous voulez.',
    cropZoom: 'Taille',
    cropWhole: 'Photo entière',
    cropCancel: 'Annuler',
    cropConfirm: 'Valider',
  },
  swipeable: {
    mute: 'Sourdine',
    pin: 'Épingler',
    unpin: 'Désépingler',
    delete: 'Effacer',
  },
  errors: {
    "Events.OrganizerRequest.AlreadyOrganizer": "Vous êtes déjà organisateur.",
    "Events.OrganizerRequest.AlreadyPending": "Vous avez déjà une demande en attente de validation.",
    "Events.OrganizerRequest.AlreadyDecided": "Cette demande a déjà été traitée.",
    "Events.OrganizerRequest.NotFound": "Cette demande est introuvable.",
    "Events.OrganizerInvitation.AccountExists": "Cette adresse a déjà un compte KeepTouch.",
    "Events.OrganizerInvitation.NotFound": "Cette invitation est introuvable (peut-être déjà utilisée ou annulée).",
    "Events.Admin.InvalidPeriod": "La période est invalide : la date de début doit précéder la date de fin.",
    "Events.Event.NotFound": "Cet événement est introuvable. Vérifiez le lien.",
    "Events.Event.InvalidDates": "La fin de l'événement doit être après son début.",
    "Events.Event.CapacityBelowAttendees": "Impossible : {attendeeCount} personnes sont déjà inscrites.",
    "Events.Organizer.Required": "Seuls les comptes organisateurs peuvent gérer des événements.",
    "Events.Organizer.NotOwner": "Vous n'êtes pas l'organisateur de cet événement.",
    "Events.Connect.CannotAddSelf": "Vous ne pouvez pas vous ajouter vous-même.",
    "Events.Attendee.NotRegistered": "Inscrivez-vous à l'événement pour voir les participants.",
    "Events.Registration.Closed": "Les inscriptions à cet événement sont fermées.",
    "Events.Registration.Full": "Cet événement est complet.",
    "Events.Price.OutOfRange": "Le prix doit être compris entre {minCents} et {maxCents} centimes (0,50 € – 10 000 €).",
    "Events.Price.LockedByPayments": "Le prix ne peut plus changer (ni l’événement devenir gratuit) : des participants ont déjà payé.",
    "Events.Payment.EventIsFree": "Cet événement est gratuit : il n’y a rien à payer.",
    "Events.Payment.NotFound": "Cette page de paiement est introuvable.",
    "Events.Payment.Expired": "La réservation a expiré et la place n’est plus disponible.",
    "Events.Payment.NotConfigured": "Le paiement n’est pas disponible pour le moment.",
    "Events.EmailCode.Invalid": "Code incorrect ou expiré. Demandez-en un nouveau.",
    "Events.EmailCode.TooManyRequests": "Trop de demandes. Réessayez dans {retryAfterSeconds} secondes.",
    "Events.EmailCode.AccountNotFound": "Aucun compte KeepTouch n'utilise cet email.",
    "Events.Event.LocationRequired": "Indiquez le nom du lieu de l'événement.",
    "Events.Event.OnlineUrlRequired": "Indiquez le lien de la visioconférence.",
    "Events.Event.InvalidRegistrationDeadline": "La date limite d'inscription doit être dans le futur.",
    "Events.Event.AlreadyEnded": "Cet événement est déjà terminé : choisissez une date de fin dans le futur.",
    "Events.Event.InvalidCoordinates": "Renseignez la latitude ET la longitude, ou aucune des deux.",
    "Events.Attendance.EventEnded": "L’événement est terminé : vous ne pouvez plus vous désinscrire.",
    "Events.CoverImage.Invalid": "Image refusée : utilisez un JPEG, PNG ou WebP de 8 Mo maximum.",
    "Events.LinkedIn.SignInFailed": "La connexion LinkedIn a échoué. Réessayez ou inscrivez-vous sans LinkedIn.",
    "Events.LinkedIn.NotConfigured": "La connexion LinkedIn n'est pas encore disponible. Inscrivez-vous sans LinkedIn.",
    "Events.Emailing.DailyLimitReached": "Limite quotidienne atteinte pour cet événement ({limit} envois par jour maximum). Réessayez demain.",
    title: 'Un problème est survenu',
    logError: 'Veuillez vous connecter de nouveau',
    sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
    sessionCheckFailed: 'Connexion instable : nouvel essai dans un instant.',
    generic: 'Une erreur est survenue. Veuillez réessayer.',
    invalidEmail:
      'Cette adresse e-mail semble incomplète ou mal écrite (exemple : prenom@exemple.com).',
    tooManyRequests: 'Trop de tentatives. Patientez quelques minutes puis réessayez.',
    'Global.ResourceNotFoundError': 'Ressource introuvable.',
    'Global.OperationNotAllowed': 'Opération non autorisée.',
    'Global.PermissionDenied': "Vous n'avez pas les droits pour effectuer cette action.",
    'Global.ResourceDeletionNotAllowed': 'Cette ressource ne peut pas être supprimée.',
    'Identity.Authentication.Unauthenticated': 'Veuillez vous reconnecter.',
    'Identity.SignIn.InvalidCredentials': 'Email ou mot de passe incorrect.',
    'Identity.Authentication.PasswordNotSet': "Ce compte n'a pas encore de mot de passe : connectez-vous avec un code reçu par email.",
    'Identity.DeleteAccount.PasswordRequired': "Pour supprimer votre compte, créez d'abord un mot de passe (Paramètres) : il sert à confirmer la suppression.",
    'Identity.Password.AlreadySet': "Ce compte a déjà un mot de passe. Utilisez « Mot de passe oublié » pour le changer.",
    'Identity.SignUp.EmailAlreadyTaken': 'Cet email est déjà utilisé.',
    'Identity.ResetPassword.InvalidOrExpiredToken':
      'Le lien de réinitialisation est invalide ou expiré.',
    'Networking.ContactRequest.SelfContactRequest':
      "Impossible de s'envoyer une demande de contact à soi-même.",
    'Networking.ContactRequest.AlreadyExists':
      'Une demande de contact existe déjà avec cette personne.',
    'Networking.ContactRequest.NotFound': 'Demande de contact introuvable.',
    'Keeptouch.ContactRequest.OnlyRecipientCanAnswer':
      'Seule la personne qui a reçu la demande peut y répondre.',
    'Networking.Avatar.InvalidImage': "Cette image n'est pas valide.",
    'Networking.Note.SharedNoteRequiresContact':
      'Une note partagée doit être associée à un contact.',
    'Networking.Note.CannotShareWithSelf': 'Impossible de se partager une note à soi-même.',
    'Networking.Note.CanOnlyShareWithContacts':
      "Une note ne peut être partagée qu'avec l'un de vos contacts.",
    'Networking.Note.OnlyAuthorCanUpdate': "Seul l'auteur de la note peut la modifier.",
    'Networking.Note.OnlyCreatorOrContactCanUpdate':
      'Seuls le créateur ou le contact lié peuvent modifier cette note.',
    'Networking.Note.SharedNoteContactMustDifferFromAuthor':
      "Le contact d'une note partagée doit être différent de l'auteur.",
    'Networking.KeepContact.OnlyCreatorCanUpdate': 'Seul le créateur peut modifier ce rappel.',
    'Networking.KeepContact.ContactNotFound': 'Contact introuvable.',
    'Networking.KeepContact.ContactAlreadyHasFollowUp': 'Ce contact a déjà un suivi.',
    'Networking.CalendarEvent.OnlyCreatorCanUpdate':
      'Seul le créateur peut modifier cet événement.',
    'Networking.CalendarEvent.OnlyCreatorCanDelete':
      "Seul l'organisateur peut supprimer ce rendez-vous.",
    'Networking.CalendarEvent.TitleRequired': 'Donnez un nom au rendez-vous.',
    'Networking.CalendarEvent.SomeParticipantsNotFound': 'Certains participants sont introuvables.',
    'Networking.ScheduledMessage.RecipientOrGroupRequired':
      'Veuillez sélectionner un destinataire ou un groupe.',
    'Networking.ScheduledMessage.GroupNotFoundOrNotMember':
      "Groupe introuvable ou vous n'en êtes pas membre.",
    'Networking.ScheduledMessage.OnlyCreatorCanUpdate':
      'Seul le créateur peut modifier ce message programmé.',
    'Networking.ScheduledMessage.ContactNotFound': 'Contact introuvable.',
    'Networking.Group.NotFoundOrNotMember':
      "Ce groupe n'existe plus, ou vous n'en faites pas partie.",
    'Networking.Contact.NotFound': 'Cette personne ne fait pas partie de vos contacts.',
    'Networking.UpdateContactScope.GhostNotAllowed':
      'Le scope ne peut être modifié que pour de vrais contacts.',
    'Networking.Profile.OnlyOwnerCanUpdate': 'Seul le propriétaire peut modifier ce profil.',
    'Networking.Hashtag.OnlyCreatorCanUpdate': 'Seul le créateur peut modifier ce hashtag.',
    'Networking.Contact.ProfileNotFound': 'Profil de contact introuvable.',
    'Networking.Contact.RelationshipNotFound': 'Relation de contact introuvable.',
    'Networking.GhostProfile.NotFound': 'Profil fantôme introuvable.',
    'Networking.GhostProfile.NoEmail': "Ce profil fantôme n'a pas d'email enregistré.",
    'Networking.MergeContacts.GhostNotFoundOrNotOwned':
      'Profil fantôme introuvable ou non possédé par vous.',
    'Networking.MergeContacts.RealContactNotFound': 'Contact réel introuvable dans vos contacts.',
    'Networking.MergeGhostProfiles.SameProfile':
      'Un profil fantôme ne peut pas être fusionné avec lui-même.',
    'Networking.MergeGhostProfiles.GhostNotFoundOrNotOwned':
      "Ce profil fantôme n'existe plus.",
    'Networking.Profile.NotFoundOrNoRelationship':
      'Profil introuvable ou pas de relation de contact.',
    'Networking.Conversation.NotFound': 'Conversation introuvable.',
    'Ft.Chatbot.ConfirmFailed':
      "L'assistant n'a pas pu confirmer le résultat. Vérifiez dans vos notes ou vos contacts si l'action a été faite avant de recommencer.",
    'Ft.Chatbot.ChatFailed': 'Le traitement du message a échoué.',
    'Ft.VoiceNote.NoAudioFile': 'Aucun fichier audio fourni.',
    'Ft.VoiceNote.ProcessingFailed': 'Le traitement de la note vocale a échoué.',
    'Ft.ConversationAi.AnalyzeFailed': "L'analyse de la conversation a échoué.",
    'Ft.ConversationAi.GenerateFailed': 'La génération de suggestions a échoué.',
    'Ft.ConversationAi.SummarizeFailed': 'Le résumé de la conversation a échoué.',
    'Ft.BusinessCard.NoImageFile': 'Aucune image fournie.',
    'Ft.BusinessCard.ScanFailed': 'Le scan de la carte de visite a échoué.',
    'Ft.SocialImport.ImportNotFound': 'Import introuvable.',
    'Ft.SocialImport.ResultsNotReady': "Les résultats de l'import ne sont pas encore disponibles.",
    'Ft.SocialImport.ResultsExpired': "Les résultats de cet import ne sont plus disponibles, relancez l'import.",
    'Ft.SocialImport.NetworkNotEnabled':
      'Le réseau "{network}" n\'est pas activé ou pas configuré.',
    'Ft.SocialImport.UnsupportedNetwork': 'Le réseau "{network}" n\'est pas supporté.',
    'Ft.SocialImport.NotInSucceededStatus': "L'import n'est pas terminé avec succès.",
    'Ft.NearbyVisibility.UpdateFailed': 'La mise à jour de la visibilité de proximité a échoué.',
    'Ft.Translate.Failed': 'La traduction a échoué.',
    'Notifications.DeviceAlreadyRegistered':
      'Cet appareil est déjà enregistré pour les notifications.',
    PLAN_LIMIT_CONTACTS_REACHED:
      'Vous avez atteint la limite de {limit} contacts du forfait gratuit. Passez à Keeptouch Infinity pour des contacts illimités.',
    PLAN_LIMIT_GHOST_PROFILES_REACHED:
      'Vous avez atteint la limite de {limit} profils fantômes du forfait gratuit. Passez à Keeptouch Infinity pour des profils fantômes illimités.',
    PLAN_LIMIT_NOTES_REACHED:
      'Vous avez atteint la limite de {limit} notes du forfait gratuit. Passez à Keeptouch Infinity pour des notes illimitées.',
    PLAN_LIMIT_REMINDERS_REACHED:
      'Vous avez atteint la limite de {limit} rappels du forfait gratuit. Passez à Keeptouch Infinity pour des rappels illimités.',
    PLAN_FEATURE_REMINDERS_DISABLED:
      'Les rappels sont réservés à Keeptouch Infinity. Passez à Keeptouch Infinity pour ne jamais oublier de garder le contact.',
    PLAN_FEATURE_EXPORT_DISABLED:
      'L’export de vos contacts est réservé à Keeptouch Infinity. Passez à Keeptouch Infinity pour les emporter partout.',
    PLAN_FEATURE_UNIPILE_DISABLED:
      'La connexion de vos réseaux et de votre agenda est réservée à Keeptouch Infinity. Passez à Keeptouch Infinity pour tout synchroniser.',
    PLAN_LIMIT_CARD_SCANS_REACHED:
      'La version gratuite permet {limit} scans de carte par mois. Passez à Keeptouch Infinity pour scanner sans limite.',
    PLAN_FEATURE_CARD_SCAN_DISABLED:
      'Le scan de carte de visite est réservé à Keeptouch Infinity.',
    AI_DAILY_LIMIT_REACHED:
      'Vous avez atteint la limite de {limit} demandes à l’IA par 24 heures. Elle se renouvelle toute seule.',
    APIFY_DAILY_LIMIT_REACHED:
      'Vous avez atteint la limite quotidienne d’imports et de recherches de profil ({limit} par 24 heures). Elle se renouvelle toute seule.',
    APIFY_IMPORT_ALREADY_RUNNING:
      'Un import de ce profil est déjà en cours. Attendez qu’il soit terminé.',
  },
  common: {
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    statusOverdue: 'Passé',
    statusUpcoming: 'À venir',
    statusDone: 'Terminé',
    all: 'Tous',
    cancel: 'Annuler',
    add: 'Ajouter',
    save: 'Sauvegarder',
    back: 'Retour',
    edit: 'Modifier',
    delete: 'Supprimer',
    confirmDelete: 'Confirmer la suppression',
    choose: 'Choisir',
    validate: 'Valider',
    private: 'Privé',
    pro: 'Pro',
    group: 'Groupe',
    personCount: '{count, plural, one {# personne} other {# personnes}}',
    resultsCount: '{count, plural, one {# résultat} other {# résultats}}',
    contactCount: '{count, plural, one {# contact} other {# contacts}}',
    memberCount: '{count, plural, one {# membre} other {# membres}}',
    parenCount: ' ({count})',
    selectedCount: '{count} sélectionné(s)',
    shared: 'Partagé',
    personal: 'Perso',
    filter: 'Filtre',
    momentFilterAll: 'Tout moment',
    momentFilterToday: "Aujourd'hui",
    momentFilterWeek: 'Cette semaine',
    momentFilterMonth: 'Ce mois',
    momentFilterLater: 'Plus tard',
    scanBusinessCard: 'Scanner une carte de visite',
    inCommon: 'En commun',
    viewMyProfile: 'Voir mon profil',
    view: 'Voir',
    retry: 'Réessayer',
  },
  featureTooltip: {
    gotIt: 'OK, compris !',
    conversation_ai_panel: {
      description:
        'Suggérer : génère une réponse. Résumer : synthèse. Analyser : sentiment et sujets.',
    },
    scheduled_messages: {
      title: 'Messages programmés',
      description:
        "Planifiez des messages à envoyer plus tard. L'IA peut générer le message pour vous selon la raison (anniversaire, prise de nouvelles...). Glissez pour modifier ou supprimer.",
    },
    scheduled_msg_reason: {
      title: 'Génération IA',
      description:
        "Choisissez une raison et ajoutez des détails optionnels. L'IA rédigera un message personnalisé adapté au contexte et à votre relation avec le contact.",
    },
    nearby_intro: {
      title: 'Contacts à proximité',
      description:
        'Découvrez quels contacts se trouvent près de vous, dans la même ville ou le même pays. Votre position est mise à jour automatiquement une fois par jour.',
    },
    keep_contact: {
      title: 'Rappels de contact',
      description:
        "Créez des rappels pour ne jamais oublier de recontacter quelqu'un. Définissez une date, une récurrence et filtrez par catégorie ou hashtag. Les rappels en retard apparaissent en rouge.",
    },
    graph_intro: {
      title: 'Graphe relationnel',
      description:
        'Explorez visuellement vos contacts et leurs relations. Zoomez, glissez et cliquez sur un contact pour voir son profil. Passez en mode Complet pour voir les liens par catégorie, hashtag, ville...',
    },
    listing_contacts: {
      title: 'Vos contacts',
      description:
        'Filtrez par Privé ou Pro avec les onglets. Utilisez le + pour ajouter un contact manuellement, scanner une carte de visite ou importer depuis un réseau social.',
    },
    card_scanner: {
      title: 'Scanner de carte de visite',
      description:
        "Prenez en photo ou importez une carte de visite. L'IA extraira automatiquement les informations et créera un nouveau contact.",
    },
    social_import: {
      title: 'Import de contacts sociaux',
      description:
        "Sélectionnez un réseau social et entrez un nom d'utilisateur. L'IA importera automatiquement les abonnés/contacts de ce profil dans votre carnet.",
    },
    merge_intro: {
      title: 'Fusionner les doublons',
      description:
        "KeepTouch repère les fiches qui portent le même nom, e-mail ou téléphone qu'un contact. Swipez à droite pour fusionner (une confirmation vous est demandée avant toute fusion), à gauche pour ignorer. Cliquez sur un profil pour le consulter avant de décider.",
    },
    classify_swipe: {
      title: 'Classez vos contacts',
      description:
        'Swipez vers la gauche pour classer en Privé, vers la droite pour Pro. Vous pouvez aussi utiliser les boutons. Cliquez sur la carte pour voir le profil.',
    },
    chatbot_intro: {
      title: 'Assistant IA',
      description:
        "Posez des questions sur vos contacts, demandez des suggestions ou effectuez des actions comme créer une note ou une fiche contact. L'IA peut chercher, analyser et agir pour vous.",
    },
  },
  graphScreen: {
    title: 'Graphe relationnel',
    nativeWebOnlyBody: 'La visualisation du graphe est disponible sur la version web.',
    nativeWebOnlySubtext:
      'Connectez-vous sur app.keeptouch.co depuis un ordinateur pour explorer vos relations de manière interactive.',
    loadingGraph: 'Chargement du graphe…',
    mode: 'Mode',
    modeContacts: 'Contacts',
    modeFull: 'Complet',
    relations: 'Relations',
    statsLine: '{nodeCount} nœuds · {edgeCount} liens',
    edgeContact: 'Contacts',
    edgeCategory: 'Catégories',
    edgeHashtag: 'Hashtags',
    edgeProfession: 'Professions',
    edgeNationality: 'Nationalités',
    edgeCity: 'Villes',
    legendMe: 'Moi',
    legendPrivate: 'Privé',
    legendPro: 'Pro',
    legendGhost: 'Fantôme',
    legendCategory: 'Catégorie',
    legendHashtag: 'Hashtag',
    legendProfession: 'Profession',
    legendNationality: 'Nationalité',
    legendCity: 'Ville',
    searchPlaceholder: 'Rechercher dans le graphe',
    loadError: 'Une erreur est survenue. Réessayez.',
  },
  geolocation: {
    unavailable: {
      title: 'Géolocalisation indisponible',
      message: "La géolocalisation n'est pas disponible sur cet appareil.",
    },
    denied: {
      title: 'Permission refusée',
      message:
        "Nous avons besoin d'accéder à votre localisation pour vous offrir une meilleure expérience. Voulez-vous ouvrir les paramètres pour activer la géolocalisation ?",
      cancel: 'Annuler',
      settings: 'Paramètres',
    },
    blocked: {
      title: 'Permission bloquée',
      message:
        "L'accès à la géolocalisation a été bloqué. Veuillez aller dans les paramètres de l'application pour l'activer manuellement.",
      cancel: 'Annuler',
      settings: 'Paramètres',
    },
  },
  contacts: {
    searchProfile: 'Rechercher un profil',
    addNonExistingProfile: 'Ajouter un profil non existant',
    importFromContacts: 'Importer depuis mes contacts',
    importFrom: 'Importer depuis {network}',
    uncontact: 'Retirer de mes contacts',
    uncontactConfirmTitle: 'ce contact',
  },
  settings: {
    notifications: 'Notifications',
    notificationsDescription: 'Choisissez quand votre téléphone vous prévient.',
    title: 'Paramètres',
    language: 'Langue',
    languageDescription: "Choisissez la langue de l'application",
    auto: "Automatique (langue de l'appareil)",
    french: 'Français',
    english: 'English',
    spanish: 'Español',
    location: 'Localisation',
    locationDescription: "L'autorisation de cet appareil, et qui voit votre position",
    locationPermission: 'Autorisation de cet appareil',
    locationPermissionGranted: 'Accordée',
    locationPermissionDenied: 'Refusée',
    locationPermissionUndetermined: 'Pas encore demandée',
    locationPermissionUnknown: 'Impossible à vérifier',
    locationAllow: 'Autoriser',
    locationVisibility: 'Qui voit ma position',
    locationDenied: 'Localisation bloquée par le navigateur. Autorisez-la pour ce site.',
    locationDeniedApp: 'Localisation refusée. Autorisez-la dans les réglages du téléphone.',
    openPhoneSettings: 'Réglages du téléphone',
    subscription: 'Abonnement',
    subscriptionDescription: 'Votre offre KeepTouch actuelle',
    legal: 'Informations légales',
    legalDescription: 'Mentions légales, confidentialité et contact.',
    subscriptionFree: 'Offre gratuite',
    subscriptionManage: 'Voir les offres Premium',
    subscriptionPremium: 'Premium actif',
    calendarSync: 'Synchronisation du calendrier',
    calendarSyncDescription: 'Ajoutez vos événements KeepTouch à votre calendrier.',
    calendarSyncEnable: 'Synchroniser avec mon calendrier',
    calendarSyncPermissionDenied: 'L’autorisation calendrier est nécessaire pour synchroniser.',
    deleteAccountTitle: 'Supprimer mon compte',
    deleteAccountDescription:
      'Supprime définitivement votre compte et toutes vos données. Cette action est irréversible.',
    deleteAccountButton: 'Supprimer mon compte',
    deleteAccountConfirmTitle: 'Supprimer votre compte ?',
    deleteAccountConfirmMessage:
      'Cette action est définitive : votre compte et toutes vos données (contacts, notes, messages…) seront supprimés. Vous ne pourrez pas les récupérer.',
    deleteAccountCancel: 'Annuler',
    deleteAccountConfirm: 'Supprimer définitivement',
    deleteAccountInProgress: 'Suppression…',
    deleteAccountPasswordPlaceholder: 'Entrez votre mot de passe',
    deleteAccountWrongPassword: 'Mot de passe incorrect.',
    deleteAccountError: 'La suppression du compte a échoué. Veuillez réessayer.',
    deleteAccountNeedPassword: 'Pour supprimer votre compte, créez d’abord un mot de passe : il sert à confirmer la suppression.',
    deleteAccountCreatePassword: 'Créer un mot de passe',
  },
  calendarModal: {
    month0: 'Janvier',
    month1: 'Février',
    month2: 'Mars',
    month3: 'Avril',
    month4: 'Mai',
    month5: 'Juin',
    month6: 'Juillet',
    month7: 'Août',
    month8: 'Septembre',
    month9: 'Octobre',
    month10: 'Novembre',
    month11: 'Décembre',
    weekDay0: 'LUN',
    weekDay1: 'MAR',
    weekDay2: 'MER',
    weekDay3: 'JEU',
    weekDay4: 'VEN',
    weekDay5: 'SAM',
    weekDay6: 'DIM',
    time: 'Heure',
    schedule: 'Programmer',
    subscriptionManage: 'Voir les offres Premium',
    subscriptionPremium: 'Premium actif',
  },
  connectedServices: {
    sectionTitle: 'Services connectés',
    sectionDescription:
      'Connectez vos messageries pour importer automatiquement vos contacts dans KeepTouch.',
    connect: 'Connecter',
    connected: 'Connecté',
    reconnect: 'Reconnecter',
    statusConnecting: 'Connexion…',
    wizardOpened: 'Finalisez la connexion dans l’onglet qui vient de s’ouvrir, puis revenez ici.',
    disconnect: 'Déconnecter',
    disconnected: 'Service déconnecté.',
    disconnectError: 'La déconnexion a échoué, réessayez.',
    wizardError: 'Impossible de créer le lien de connexion, réessayez.',
    refresh: 'Actualiser',
    filterPlaceholder: 'Filtre (optionnel) : ex. cybersécurité, finance, recrutement…',
    syncFilteredOut: '{filtered} contact(s) hors critère non importé(s)',
    syncTruncated: 'Seuls les 500 premiers contacts de ce service ont été lus.',
    syncStarted: "Importation lancée — cela peut prendre quelques minutes. Inutile de déconnecter le service, tout arrive ! ⏳",
    syncInProgressHint: "Importation en cours… Cela peut prendre quelques minutes, vous pouvez continuer à utiliser l'application.",
    syncNow: 'Importer mes contacts',
    syncing: 'Import en cours…',
    syncResult: '{created} contact(s) importé(s), {skipped} déjà présent(s)',
    syncEmpty: 'Aucun nouveau contact à importer',
    syncError: 'L’import a échoué, réessayez.',
    planLimit: 'Limite du plan gratuit atteinte — certains contacts n’ont pas été importés.',
    noAccounts: 'Aucun service connecté pour l’instant.',
    serviceInstagram: 'Instagram',
    serviceWhatsapp: 'WhatsApp',
    serviceLinkedin: 'LinkedIn',
    serviceGmail: 'Gmail',
    calendarSync: 'Synchroniser Google Agenda',
    calendarSyncing: 'Synchronisation…',
    calendarConnect: 'Connecter Google Agenda',
    calendarSyncResult: '{created} événement(s) importé(s), {skipped} déjà présent(s)',
    calendarSyncEmpty: 'Agenda déjà à jour',
    calendarSyncError: 'La synchronisation a échoué, réessayez.',
  },
  subscription: {
    title: 'Abonnement',
    headline: 'Choisissez votre expérience Keeptouch',
    intro: 'Deux formules pour développer et entretenir votre réseau humain, à votre rythme.',
    // Version Gratuite
    freeTierTitle: 'Version Gratuite',
    freeTierSubtitle: 'Pour découvrir Keeptouch et structurer ses premiers contacts.',
    freePriceLabel: 'Gratuit',
    freeFeatureContacts: 'Jusqu’à {count} contacts',
    freeFeatureGhosts: '{count} profils fantômes',
    freeFeatureNotes: '{count} notes personnelles',
    freeFeatureReminders: '{count} rappels Garder contact',
    // Keeptouch Infinity
    infinityTierTitle: 'Keeptouch Infinity',
    infinityTierSubtitle: 'L’expérience complète pour les bâtisseurs de réseau humain.',
    infinityBadge: 'Recommandé',
    infinityPriceFallback: '6,99 €/mois',
    infinityPricePerMonth: '{price}/mois',
    infinityFeatureContacts: 'Contacts et profils fantômes illimités',
    infinityFeatureNotes: 'Notes personnelles illimitées',
    infinityFeatureReminders: 'Rappels Garder contact illimités',
    infinityFeatureIntegrations: 'Connexion de vos réseaux et de votre agenda',
    infinityFeatureExport: 'Export de vos contacts (.vcf)',
    infinityCta: 'Lancer Keeptouch Infinity',
    comingSoon: 'Bientôt disponible',
    comingSoonMessage: 'Keeptouch Infinity arrive très bientôt. Merci de votre patience !',
    premiumTitle: 'Vous êtes Infinity',
    premiumSubtitle: 'Merci de faire partie de Keeptouch Infinity. Vous profitez de toutes les fonctionnalités, sans limite.',
    premiumActive: 'Abonnement actif',
    expiresOn: 'Renouvellement le {date}',
    endsOn: 'Votre abonnement se termine le {date}',
    offeredUntil: 'Accès offert jusqu’au {date}',
    currentPeriodUntil: 'Période en cours jusqu’au {date}',
    processing: 'Traitement…',
    activating: 'Activation de votre abonnement…',
    activationPendingTitle: 'Paiement reçu',
    activationPendingMessage:
      'L’activation peut prendre quelques minutes. Cette page se mettra à jour toute seule.',
    purchaseSuccessTitle: 'Bienvenue chez Keeptouch Infinity',
    purchaseSuccessMessage: 'Votre abonnement est actif. Profitez de toutes les fonctionnalités !',
    purchaseErrorTitle: 'Achat impossible',
    purchaseErrorMessage: 'L’achat n’a pas pu aboutir. Veuillez réessayer.',
    restoreCta: 'Restaurer mes achats',
    restoring: 'Restauration…',
    restoreSuccessTitle: 'Abonnement restauré',
    restoreSuccessMessage: 'Votre abonnement Infinity a bien été restauré.',
    restoreNoneTitle: 'Aucun achat à restaurer',
    restoreNoneMessage: 'Nous n’avons trouvé aucun abonnement actif sur ce compte.',
    restoreErrorTitle: 'Restauration impossible',
    restoreErrorMessage: 'La restauration a échoué. Veuillez réessayer.',
    manageCta: 'Gérer mon abonnement',
    manageErrorTitle: 'Ouverture impossible',
    manageErrorMessage: 'Impossible d’ouvrir la page de gestion de l’abonnement.',
    cancelCta: 'Arrêter mon abonnement',
    cancelConfirmQuestion: 'Êtes-vous sûr de vouloir arrêter votre abonnement ?',
    cancelConfirmUntilDate:
      'Vous garderez toutes les fonctionnalités Keeptouch Infinity jusqu’au {date}, puis votre compte repassera en version gratuite.',
    cancelConfirmUntilPeriodEnd:
      'Vous garderez toutes les fonctionnalités Keeptouch Infinity jusqu’à la fin de la période déjà payée, puis votre compte repassera en version gratuite.',
    cancelConfirmYes: 'Oui, arrêter mon abonnement',
    cancelConfirmNo: 'Non, garder mon abonnement',
    cancelOfferedTitle: 'Abonnement offert',
    cancelOfferedMessage:
      'Votre accès Keeptouch Infinity vous a été offert : aucun paiement n’est en cours, il n’y a donc rien à arrêter.',
    cancelUnavailableTitle: 'Arrêt impossible pour le moment',
    cancelUnavailableMessage:
      'Nous n’avons pas pu ouvrir la page pour arrêter votre abonnement. Veuillez réessayer dans quelques instants.',
    legalDisclosure:
      'Abonnement mensuel à renouvellement automatique de 6,99 €/mois. Il se renouvelle automatiquement sauf résiliation au moins 24 h avant la fin de la période. Résiliable à tout moment dans les réglages de votre compte.',
    termsOfUse: 'Conditions d’utilisation',
    privacyPolicy: 'Politique de confidentialité',
  },
  planLimit: {
    title: 'Passez à Keeptouch Infinity',
    body: 'Vous avez atteint une limite du forfait gratuit. Passez à Keeptouch Infinity pour débloquer cette fonctionnalité.',
    upgrade: 'Passer à Keeptouch Infinity',
    later: 'Plus tard',
    close: 'Fermer',
    noCommitment: 'Sans engagement',
    cancelAnytime: 'Résiliable à tout moment',
    included: 'Ce qui est inclus',
  },
  export: {
    sectionTitle: 'Exporter mes contacts',
    sectionDescription:
      'Téléchargez tous vos contacts au format vCard (.vcf), réimportable dans n’importe quel carnet d’adresses.',
    cta: 'Exporter mes contacts (.vcf)',
    exporting: 'Export en cours…',
    successTitle: 'Export réussi',
    successMessage: 'Vos contacts ont été exportés au format vCard.',
    emptyTitle: 'Aucun contact à exporter',
    emptyMessage: "Ajoutez des contacts, puis relancez l'export.",
  },
  eventsExport: {
    sectionTitle: 'Mes données d’événements',
    sectionDescription:
      'Téléchargez gratuitement vos inscriptions, votre présence, vos paiements, les invitations reçues, les contacts ajoutés via un événement et vos demandes d’organisateur.',
    ctaJson: 'Exporter (JSON)',
    ctaCsv: 'Exporter (tableur CSV)',
    exporting: 'Export en cours…',
    successTitle: 'Export réussi',
    successMessage: 'Vos données d’événements ont été exportées.',
  },
  recurrence: {
    title: 'Récurrence',
    custom: 'Personnalisée',
    recurrence: 'Récurrence',
    every: 'Tous les',
    everyDay: 'Tous les jours',
    everyWeek: 'Toutes les semaines',
    every2Weeks: 'Toutes les 2 semaines',
    every6Weeks: 'Toutes les 6 semaines',
    everyMonth: 'Tous les mois',
    every3Months: 'Tous les 3 mois',
    every6Months: 'Tous les 6 mois',
    everyYear: 'Tous les ans',
    repeatOn: 'Répéter le',
    end: 'Fin',
    never: 'Jamais',
    on: 'Le',
    after: 'Après',
    lastDayOfMonth: 'Dernier jour du mois',
    day: 'jour',
    week: 'semaine',
    month: 'mois',
    year: 'an',
    repetition: 'répétition',
  },
  calendarEvent: {
    createEvent: 'Créer un rendez-vous',
    editEvent: 'Modifier le rendez-vous',
    shared: 'Partagé',
    sharedCount: '{count, plural, one {Partagé} other {Partagés}}',
    personal: 'Perso',
    eventName: 'Nom du rendez-vous',
    eventNamePlaceholder: 'Nom du rendez-vous...',
    addGuests: 'Ajouter des invités',
    searchGuests: 'Rechercher des invités...',
    addPeoplePrivate: 'Personnes concernées',
    searchPeoplePrivate: 'Rechercher une personne...',
    privatePeopleHint: 'Elles ne sont pas prévenues et ne voient pas ce rendez-vous.',
    eventDate: "Date de l'évènement",
    allDay: 'Toute la journée',
    addLocation: 'Ajouter un lieu',
    locationTitle: 'Lieu',
    description: 'Description',
    descriptionPlaceholder: 'Description...',
    alert: 'Alerte',
    alertEnabled: 'Alerte activée',
    noAlert: 'Aucune alerte',
    inviteAndAdd: 'Inviter et ajouter sur KeepTouch',
    addToCalendar: 'Ajouter seulement sur KeepTouch',
    addToGoogle: 'Ajouter à Google Agenda',
    deleteConfirm: 'Supprimer ce rendez-vous ?',
    markAsDone: 'Marquer comme fait',
    markAsNotDone: 'Marquer comme non fait',
    birthdayOn: 'Anniversaire : {date}',
    keepContactPlannedOn: 'Garder contact : rappel prévu le {date}',
    titleRequired: 'Donnez un nom au rendez-vous.',
    endBeforeStart: 'La fin du rendez-vous est avant son début.',
  },
  ghostProfile: {
    inviteToJoin: 'Inviter à rejoindre',
    inviteSent: 'Invitation envoyée par e-mail.',
    inviteAgain: 'Réinviter',
    inviteConfirmTitle: 'Inviter {name} ?',
    inviteConfirmBody:
      "Un e-mail d'invitation sera envoyé à {email}, avec un lien pour créer un compte et vous retrouver sur KeepTouch.",
    inviteConfirmAgain:
      "Vous avez déjà invité {name} le {date}. Renvoyer l'invitation à {email} ?",
    inviteSend: 'Envoyer',
    inviteError: "Impossible d'envoyer l'invitation. Veuillez réessayer.",
    inviteErrorNoEmail:
      "Ce profil n'a pas d'adresse e-mail. Ajoutez une adresse e-mail pour envoyer une invitation.",
    editProfile: 'Modifier le profil',
    about: 'À propos',
    presentation: 'Présentation',
    birthday: 'Anniversaire',
    languages: 'Langues',
    nationalities: 'Nationalités',
    origins: 'Origines',
    contactInfo: 'Coordonnées',
    email: 'Mail',
    phone: 'Numéro',
    website: 'Site web',
    availabilities: 'Disponibilités',
    livedPlaces: 'Lieux de résidence',
    categories: 'Catégories',
    searchCategories: 'Rechercher des catégories',
    keepContact: 'Garder contact',
    context: 'Contexte',
    hashtag: 'Hashtag',
    searchHashtags: 'Rechercher des hashtags',
    hashtags: 'Hashtags',
    objectives: 'Objectifs',
    hobby: 'Hobby',
    skills: 'Compétences',
    notes: 'Notes',
    appointments: 'Rendez-vous / Rappel',
    memories: 'Souvenirs',
    shareProfile: 'Partager',
    message: 'Message',
    requestSent: 'Demande envoyée',
    openOnKeepTouch: 'Ouvrir sur KeepTouch',
    edit: 'Modifier',
    deleteProfile: 'Supprimer le profil',
    deleteConfirmTitle: 'ce profil fantôme',
    deleteConfirmMessage:
      'Supprimer ce profil fantôme ? Les notes et les suivis liés à cette personne seront supprimés définitivement avec lui. Cette action est irréversible.',
    deleteSuccess: 'Profil fantôme supprimé',
    updateSuccess: 'Profil fantôme mis à jour',
    createSuccess: 'Profil fantôme créé',
    lastInteraction: 'Dernière interaction {time}',
    noInteractionYet: "Aucune interaction pour l'instant",
    viewMyProfile: 'Voir mon profil',
    aboutProfile: 'À propos du profil',
    pins: 'Pins',
    strangerNotice: 'Ajoutez {name} à vos contacts pour voir le reste de son profil.',
    strangerNoticePending:
      "Le reste du profil de {name} s'affichera quand votre demande sera acceptée.",
    strangerNoticeReceived:
      '{name} souhaite vous ajouter à ses contacts. Acceptez sa demande pour voir le reste de son profil.',
    cancelRequest: 'Annuler la demande',
    cancelRequestHeading: 'Annuler la demande',
    cancelRequestTitle: 'Annuler la demande envoyée à {name} ?',
    notFoundTitle: 'Profil introuvable',
    notFoundMessage:
      'Ce lien ou ce QR code ne correspond à aucun profil. Il est peut-être ancien, ou le compte a été supprimé.',
    loadErrorTitle: 'Impossible de charger ce profil',
    loadErrorMessage: 'Vérifiez votre connexion, puis réessayez.',
  },
  contextes: {
    title: 'Contextes',
    meetingContext: 'Cadre de la rencontre',
    associatedEmotion: 'Émotion associée',
    relationshipEvolution: 'Évolution de la relation',
    relationshipAutomatic: "Calculée automatiquement d'après vos messages",
    associatedColor: 'Couleur associée',
    referencePlace: 'Lieu de référence',
    enterPlace: 'Entrez un lieu',
    chooseMeetingContext: 'Choisir le cadre de la rencontre',
    editMeetingContext: 'Modifier le cadre de la rencontre',
    chooseEmotion: "Choisir l'émotion associée",
    editEmotion: "Modifier l'émotion associée",
    chooseRelationship: "Choisir l'évolution de la relation",
    editRelationship: "Modifier l'évolution de la relation",
    chooseColor: 'Choisir la couleur associée',
    editColor: 'Modifier la couleur associée',
    searchMeetingContext: 'Rechercher un cadre de la rencontre',
    searchEmotion: 'Rechercher une émotion associée',
    searchRelationship: 'Rechercher une évolution de la relation',
    searchColor: 'Rechercher une couleur associée',
    save: 'Sauvegarder',
    unsavedTitle: 'Modifications non sauvegardées',
    unsavedMessage: 'Êtes-vous sûr de ne pas sauvegarder ?',
    leaveWithoutSaving: 'Quitter sans sauvegarder',
    keepEditing: 'Annuler',
  },
  categories: {
    notFound: 'Catégorie non trouvée',
    gallery: 'Galerie',
    camera: 'Appareil photo',
    person: 'personne',
    persons: 'personnes',
  },
  importContacts: {
    back: 'Retour',
    importCard: 'Importer une carte de visite',
    businessCard: 'Carte de visite',
    dragCard: 'Faites glisser la carte de visite ici',
    or: 'Ou',
    selectFiles: 'Sélectionner parmi vos fichiers',
    supportedFormats: 'Format pris en charge : PDF, JPEG, PNG',
    startImport: "Lancer l'import",
    contactFound: 'Contact trouvé sur KeepTouch',
    profileFound: 'Profil trouvé!',
    addNewContact: 'Ajouter un nouveau contact :',
    validate: 'Valider et enregistrer la fiche',
    validating: 'Enregistrement…',
    checkInfo: 'Vérifier les informations importées',
    alreadySaved: 'Ce contact est déjà dans votre liste. « Valider » enregistre vos corrections.',
    discard: 'Ne pas garder ce contact',
    firstName: 'Prénom',
    enterFirstName: 'Entrez le prénom',
    lastName: 'Nom',
    enterLastName: 'Entrez le nom',
    profession: 'Profession',
    enterProfession: 'Entrez la profession',
    company: 'Entreprise',
    enterCompany: "Entrez l'entreprise",
    email: 'Email',
    phone: 'Téléphone',
    address: 'Adresse',
    website: 'Site web',
    hashtag: 'Hashtag',
    hashtagPlaceholder: 'Nom du #...',
    categoriesLabel: 'Catégories',
    searchProfession: 'Rechercher une profession',
    file: {
      title: 'Importer depuis un fichier CSV',
      subtitle:
        'Déposez un export CSV de votre CRM ou de Google Contacts : vous vérifiez les colonnes, puis un profil fantôme est créé pour chaque contact qui n’est pas déjà dans les vôtres.',
      drag: 'Faites glisser votre fichier ici',
      formats: 'Format pris en charge : CSV (.csv)',
      fullName: 'Nom complet',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      facebook: 'Facebook',
      twitter: 'Twitter / X',
      notes: 'Notes',
      unsupportedFormat: 'Format non pris en charge. Choisissez un fichier CSV (.csv). Les fichiers Excel doivent d’abord être exportés en CSV.',
      empty: 'Le fichier ne contient aucune ligne de contact.',
      parseError: "Impossible de lire le fichier. Vérifiez qu'il est bien au format CSV.",
      detected: '{count} contact(s) détecté(s) dans le fichier',
      columnsDetected: 'Vérifiez les colonnes avant d’importer :',
      columnsTitle: 'Colonnes du fichier',
      ignoreColumn: 'Ignorer',
      sample: 'Exemple : {value}',
      previewTitle: 'Aperçu',
      noUsableRows: 'Aucune ligne exploitable : il faut au moins un nom, un email ou un téléphone.',
      importButton: 'Importer {count} contact(s)',
      importing: 'Création des profils… {done} / {total}',
      doneTitle: '{count} contact(s) importé(s) avec succès',
      doneDuplicates: '{count} déjà dans vos contacts, non réimporté(s)',
      doneIgnored: '{count} ligne(s) ignorée(s) : ni nom, ni email, ni téléphone',
      doneFailed: '{count} contact(s) refusé(s) :',
      doneLimit: 'Limite de votre formule atteinte : {count} contact(s) non importé(s)',
      failureLine: 'Contact n° {row} — {name} : {reason}',
      moreFailures: 'et {count} autre(s)',
      importAnother: 'Importer un autre fichier',
      importedToast: '{count} profil(s) fantôme(s) créé(s)',
    },
  },
  contactsList: {
    noContactFound: 'Aucun contact trouvé',
    contactViaSocial: 'Contacter via les réseaux sociaux',
  },
  socialNetwork: {
    contactViaLinkedin: 'Contacter via LinkedIn',
    contactViaFacebook: 'Contacter via Facebook',
    contactViaInstagram: 'Contacter via Instagram',
    contactViaTwitter: 'Contacter via Twitter',
  },
  keepContact: {
    editReminder: 'Modifier le suivi',
    createReminder: 'Créer un suivi',
    reminderTitle: 'Titre du suivi',
    reminderTitlePlaceholder: 'Nom du suivi...',
    description: 'Description',
    descriptionPlaceholder: 'Description...',
    addContact: 'Ajouter un contact',
    searchContact: 'Rechercher un contact...',
    contactLabel: 'Contact',
    eventDate: "Date de l'évènement",
    addLocation: 'Ajouter un lieu',
    location: 'Lieu',
    alert: 'Alerte',
    alertEnabled: 'Alerte activée',
    noAlert: 'Aucune alerte',
    alertActive: 'Active',
    alertInactive: 'Non active',
    backToProfile: 'Retour au profil',
    pageTitle: 'Garder contact',
    reminder: 'suivi',
    reminders: 'suivis',
    statusLate: 'En retard',
    deleteConfirm: 'ce suivi',
    filter: 'Filtre',
    none: 'Aucune récurrence',
    keepContactWith: 'Garder contact avec {contactName}',
    listView: 'Liste',
    boardView: 'Tableau',
  },
  photoAlert: {
    title: 'Choisir une photo',
    message: 'Sélectionnez une option',
  },
  qrCode: {
    shareMessage: 'Découvrez mon profil KeepTouch : {url}',
    shareTitle: 'Mon profil KeepTouch',
    error: 'Erreur',
    shareError: 'Impossible de partager le profil',
    success: 'Succès',
    linkCopied: 'Lien copié dans le presse-papiers',
    copyError: 'Impossible de copier le lien',
    info: 'Information',
    downloadTodo: 'Fonctionnalité de téléchargement à implémenter',
    downloaded: 'QR code téléchargé',
    downloadError: 'Impossible de télécharger le QR code',
    notKeepTouchUrl: 'Ce QR code ne contient pas de lien vers un profil KeepTouch.',
    scanTitle: 'Scanner un QR Code',
    scanInstruction: 'Pointez votre caméra vers un QR code KeepTouch pour le scanner.',
    scanWebFallbackActive: 'Utilisation du scanner alternatif pour votre navigateur.',
    cameraPermissionTitle: 'Accès à la caméra requis',
    cameraPermissionMessage:
      "Veuillez autoriser l'accès à la caméra dans les paramètres de votre navigateur pour scanner des QR codes.",
    cameraPermissionMessageApp: 'Autorisez KeepTouch à utiliser la caméra pour scanner un QR code.',
    allowCamera: 'Autoriser la caméra',
    openSettings: 'Ouvrir les réglages',
  },
  webNav: {
    search: 'Rechercher',
    allContacts: 'Tous mes contacts',
    messaging: 'Messagerie',
    notifications: 'Notifications',
    myProfile: 'Mon profil',
    signOut: 'Se déconnecter',
    settings: 'Paramètres',
  },
  menuItems: {
    admin: "Administration",
    events: "Événements",
    importContacts: 'Importer des contacts',
    classifyProfiles: 'Classer des profils',
    mergeProfiles: 'Fusionner des profils',
    maps: 'Cartes',
    notes: 'Notes',
    categories: 'Catégories',
    hashtags: 'Hashtags',
    relationalColors: 'Couleurs relationnelles',
    appointments: 'Rendez-vous / Rappel',
    birthdays: 'Anniversaires',
    keepContact: 'Garder contact',
    scheduledMessages: 'Messages programmés',
    qrCode: 'QR code',
    settings: 'Paramètres',
    graph: 'Graphe relationnel',
    nearby: 'Contacts à proximité',
  },
  form: {
    contactInfo: 'Info de contact',
    about: 'À propos',
    woman: 'Une femme',
    man: 'Un homme',
    mainInfo: 'Informations principales',
    firstName: 'Prénom',
    enterFirstName: 'Entrez le prénom',
    lastName: 'Nom',
    enterLastName: 'Entrez le nom',
    professions: 'Profession(s)',
    enterProfession: 'Entrez la profession',
    company: 'Entreprise',
    enterCompany: "Nom de l'entreprise (facultatif)",
    email: 'Email',
    phoneNumber: 'Numéro de téléphone',
    socialNetworks: 'Réseaux sociaux',
    website: 'Site web',
    descriptionPlaceholder: 'Description...',
    presentation: 'Présentation',
    birthDate: 'Date de naissance',
    livingPlace: 'Lieu de vie',
    origins: 'Origines',
    nationalities: 'Nationalités',
    nationalityPlaceholder: 'Nationalité',
    spokenLanguages: 'Langues parlées',
    enterLanguages: 'Entrez les langues',
    livedPlaces: 'Lieux vécus',
    hashtags: 'Hashtags',
    availabilityAndMeetings: 'Disponibilités et types de rencontres',
    availability: 'Disponibilités',
    bestMoment: 'Meilleur moment',
    bestMoments: 'Meilleurs moments',
    chooseDay: 'Choisir un jour',
    chooseTime: "Choisir l'heure",
    days: {
      sunday: 'Dimanche',
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
    },
    searchLanguage: 'Rechercher une langue',
    searchPlace: 'Rechercher un lieu',
    searchNationality: 'Rechercher une nationalité',
    searchHashtags: 'Rechercher des hashtags',
    searchCategories: 'Rechercher des catégories',
    searchProfession: 'Rechercher une profession',
    backToProfile: 'Retour au profil',
    backToContacts: 'Retour à la liste des contacts',
    editGhostProfile: 'Modifier le profil fantôme',
    createGhostProfile: 'Créer un profil fantôme',
    addMeetingContext: 'Ajouter cadre de rencontre',
    addNewProfile: 'Ajouter un nouveau profil',
    addContact: 'Ajouter un contact',
    searchContact: 'Rechercher un contact...',
    addNonExistingProfile: 'Ajouter un profil non existant',
  },
  messaging: {
    searchPlaceholder: 'Rechercher un message ou un contact',
    groupNamePlaceholder: 'Nom du groupe (optionnel)',
    recipientPlaceholder: 'Saisir votre destinataire...',
    messagePlaceholder: 'Saisissez votre message ...',
    draftPending: 'Préparation de votre message…',
    seen: 'Vu',
    photo: '📷 Photo',
    noMessages: 'Aucun message',
    aboutGroup: 'À propos du groupe',
    createNewMessage: 'Créer un nouveau message',
  },
  profileEdit: {
    editMyProfile: 'Modifier mon profil',
    backToMyProfile: 'Retour à mon profil',
    about: 'À propos :',
    categories: 'Catégories',
    searchCategories: 'Rechercher des catégories',
  },
  livingPlaceForm: {
    editTitle: 'Modifier le lieu de résidence',
    addTitle: 'Ajouter un lieu de résidence',
    place: 'Lieu',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    currently: 'Actuellement',
  },
  notesForm: {
    addNote: 'Ajouter une note',
    editNote: 'Modifier la note',
    titlePlaceholder: 'Titre',
    notePlaceholder: 'Note',
    sharedWith: 'Partagée avec ',
    whoCanRead: 'Qui peut lire cette note ?',
    onlyMe: 'Moi seul',
    onlyMeSubtitle: 'Note personnelle',
    meAnd: 'Moi et {name}',
    meAndSubtitle: '{name} la verra dans son appli',
    dictate: 'Dicter',
    pin: 'Épingler',
    unpin: 'Désépingler',
    autoSave: 'Enregistrement automatique',
    about: 'À propos de',
    choosePerson: 'Choisir une personne',
    change: 'Changer',
    seeProfile: 'Voir la fiche',
    lastExchange: 'Dernier échange :',
    noExchangeYet: "Pas encore d'échange",
    otherNotes:
      '{count, plural, =0 {Aucune autre note sur {name}} one {# autre note sur {name}} other {# autres notes sur {name}}}',
    see: 'Voir',
    meAndThisPerson: 'Moi et cette personne',
    chooseFirst: "Choisissez d'abord une personne",
    ghostNoApp: "Ce profil n'a pas l'appli",
    notAddedBack: 'Cette personne ne vous a pas encore ajouté',
    savedForMeOnly: 'Cette personne ne vous a pas encore ajouté : la note est enregistrée pour vous seul.',
    date: 'Date',
    writtenOn: 'Écrite le {date}',
    todayDate: "Aujourd'hui, {date}",
    allProfiles: 'Tous',
    allProfilesCount: 'Tous vos profils · {count}',
    privateCount: 'Privé · {count}',
    proCount: 'Pro · {count}',
    ghostCount: 'Fantômes · {count}',
    noProfileFound: 'Aucun profil trouvé',
    removePerson: 'Retirer la personne de la note',
    pinned: 'Épinglée',
    pinnedWhere: 'Épinglée · dans « À retenir » de {name}',
    pinnedTop: 'Épinglée · en haut de vos notes',
    meAndSomeone: 'Moi et …',
    done: 'OK',
    changePerson: 'Changer de personne',
    noteWrittenOn: 'Note écrite le {date}',
    today: "Aujourd'hui",
  },
  recurrenceComponent: {
    everyDay: 'Tous les jours',
    everyWeek: 'Toutes les semaines',
    everyMonth: 'Tous les mois',
    everyYear: 'Tous les ans',
    recurrence: 'Récurrence',
    every: 'Tous les',
    repeatOn: 'Répéter le',
    monthDetail: 'Détail par mois',
    lastDayOfMonth: 'Dernier jour du mois',
    end: 'Fin',
    never: 'Jamais',
    on: 'Le',
    after: 'Après',
    day: 'jour',
    days: 'jours',
    week: 'semaine',
    weeks: 'semaines',
    month: 'mois',
    year: 'an',
    years: 'ans',
    repetition: 'répétition',
    repetitions: 'répétitions',
  },
  filters: {
    title: 'Filtres',
    gender: 'Sexe',
    age: 'Âge',
    min: 'Min',
    max: 'Max',
    ageYears: '{count} ans',
    ageMin: 'Âge minimum',
    ageMax: 'Âge maximum',
    genderFemale: 'F',
    genderMale: 'M',
    genderNonBinary: 'NB',
    genderFemaleLong: 'Féminin',
    genderMaleLong: 'Masculin',
    genderNonBinaryLong: 'Non binaire',
    residence: 'Lieu de vie',
    residenceContinent: 'Continent',
    residenceCountry: 'Pays',
    residenceRegion: 'Région',
    residenceCity: 'Ville',
    livedPlaces: 'Lieux vécus',
    origin: 'Origine',
    nationality: 'Nationalité',
    profession: 'Fonction',
    meetingContext: 'Cadre de la rencontre',
    associatedEmotion: 'Émotion associée',
    relationshipEvolution: 'Évolution de la relation',
    associatedColor: 'Couleur associée',
    language: 'Langue',
    category: 'Catégorie',
    hashtag: 'Hashtag',
    searchPlace: 'Rechercher un lieu',
    activitySector: "Secteur d'activité",
    searchSector: 'Rechercher un secteur',
    searchHashtags: 'Rechercher des hashtags',
    searchHashtag: 'Rechercher un hashtag',
    searchCategories: 'Rechercher des catégories',
    searchCategory: 'Rechercher une catégorie',
    searchMeetingContext: 'Rechercher un cadre de la rencontre',
    searchEmotion: 'Rechercher une émotion associée',
    searchRelationship: 'Rechercher une évolution de la relation',
    searchColor: 'Rechercher une couleur associée',
    searchLanguage: 'Rechercher une langue',
    contact: 'Contact',
    eventDate: "Date de l'évènement",
    addPlace: 'Ajouter un lieu',
    place: 'Lieu',
  },
  hashtagForm: {
    addTitle: 'Ajouter un hashtag',
    editTitle: 'Modifier le hashtag',
    backToList: 'Retour à la liste des hashtags',
    namePlaceholder: 'Nom...',
  },
  deleteModal: {
    confirmMessage: 'Êtes-vous sûr de vouloir supprimer {title} ?',
    delete: 'Supprimer',
    cancel: 'Annuler',
  },
  relationalColorForm: {
    editTitle: 'Modifier la couleur relationnelle',
    namePlaceholder: 'Nom...',
  },
  addContactModal: {
    addPerson: 'Ajouter {name}',
    addDefaultPerson: 'Ajouter nom de la personne',
    addPrivate: 'Ajouter en Privé',
    addProfessional: 'Ajouter en Professionnel',
    requestSent: 'Demande envoyée',
  },
  addHashtagModal: {
    title: 'Ajouter un hashtag',
    save: 'Enregistrer',
  },
  addCategoryModal: {
    title: 'Ajouter une catégorie',
    save: 'Enregistrer',
  },
  menuContactsList: {
    addContacts: 'Ajouter des contacts',
    linkedContacts: 'Contacts liés',
  },
  memoriesForm: {
    addPhoto: 'Ajouter une photo',
    editMemory: 'Modifier le souvenir',
    addMemory: 'Ajouter un souvenir',
    memory: 'Souvenir',
    selectMemory: 'Sélectionnez un souvenir',
    description: 'Description :',
    identifyContacts: 'Identifier des contacts :',
    identifiedContacts: 'Contacts identifiés',
    publish: 'Publier',
    sharedMemories: 'Souvenirs partagés',
    sharedAlbums: 'Albums partagés',
    deleteMemoryDescription: "Voulez-vous supprimer uniquement cette photo ou l'album entier ?",
    deletePhoto: 'Supprimer cette photo',
    deleteAlbum: "Supprimer l'album",
    deleteAlbumDescription: 'Êtes-vous sûr de vouloir supprimer cet album entièrement ?',
  },
  albums: {
    title: 'Albums',
    createAlbum: 'Créer un album',
    albumName: "Nom de l'album",
    albumTitle: "Titre de l'album",
    defaultTitle: 'Mon album',
    description: 'Description',
    empty: 'Aucun album pour le moment',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet album ?',
  },
  creationStack: {
    addNote: 'Ajouter une note',
    conversation: 'Conversation',
    createEvent: 'Créer un événement',
    addReminder: 'Ajouter un rappel',
    scheduleMessage: 'Programmer un message',
    composeMessage: 'Rédiger un message',
  },
  calendarAddEvent: {
    notActive: 'Non active',
    active: 'Active',
  },
  toast: {
    success: 'Succès',
    error: 'Erreur',
    info: 'Info',
    scheduledMessageDeleted: 'Message programmé supprimé',
    scheduledMessageCreated: 'Message programmé créé',
    scheduledMessageUpdated: 'Message programmé mis à jour',
    reminderUpdated: 'Rendez-vous / Rappel mis à jour',
    reminderDeleted: 'Rendez-vous / Rappel supprimé',
    reminderCreated: 'Rendez-vous / Rappel créé',
    eventDeleted: 'Événement supprimé',
    eventCreated: 'Événement créé',
    eventUpdated: 'Événement mis à jour',
    colorUpdated: 'Couleur mise à jour',
    contactRequestSent: 'Demande envoyée',
    contactRequestSentMessage: "Votre demande d'ami a bien été envoyée.",
    contactRequestCancelled: 'Demande annulée',
    scopeChanged: 'Scope modifié',
    categoryUpdated: 'Catégorie mise à jour',
    categoryCreated: 'Catégorie créée',
    categoryDeleted: 'Catégorie supprimée',
    noteCreated: 'Note créée',
    noteUpdated: 'Note mise à jour',
    noteDeleted: 'Note supprimée',
    hashtagUpdated: 'Hashtag mis à jour',
    hashtagDeleted: 'Hashtag supprimé',
    hashtagCreated: 'Hashtag créé',
    memoryCreated: 'Souvenir ajouté',
    memoryUpdated: 'Souvenir modifié',
    memoryDeleted: 'Souvenir supprimé',
    albumCreated: 'Album créé',
    albumDeleted: 'Album supprimé',
  },
  voiceNote: {
    error: 'Erreur lors du traitement de la note vocale',
    vocal: 'Vocal',
    successProfileUpdated: 'Profil mis à jour',
    successNoteCreated: 'Note créée',
    successProcessed: 'Note vocale traitée',
    micUnavailableTitle: 'Micro indisponible',
    micUnavailableMessage:
      'Autorisez le micro pour KeepTouch dans les réglages de votre navigateur ou de votre téléphone, puis réessayez.',
  },
  messagesScreen: {
    private: 'Privé',
    pro: 'Pro',
    groups: 'Groupes',
    other: 'Autre',
    pinnedMessages: 'Voir les messages épinglés',
    viewNotes: 'Voir les notes',
    viewMedia: 'Voir les médias',
    viewMembers: 'Voir les membres',
    customizeGroup: 'Personnaliser le groupe',
    share: 'Partager',
    block: 'Bloquer',
    report: 'Signaler',
    group: 'Groupe',
    members: 'Membres',
    persons: '{count} personnes',
  },
  contactsScreen: {
    personFound: 'personne trouvée',
    personsFound: 'personnes trouvées',
    noContactFound: 'Aucun contact trouvé',
    professionNotSpecified: 'Profession non renseignée',
    profilesRemainingToMerge: 'profils restants à fusionner',
    profileRemainingToMerge: 'profil restant à fusionner',
    noProfileToMerge: 'Aucun profil à fusionner',
    mergeProfiles: 'Fusionner les profils',
    merge: 'Fusionner',
    swipeToMerge: 'Swiper à droite pour fusionner, à gauche pour ignorer.',
    swipeMergeInstruction: 'Swiper à droite pour fusionner, à gauche pour ignorer.',
    profilesRemainingToClassify: 'profils restants à classer',
    profileRemainingToClassify: 'profil restant à classer',
    noProfileToClassify: 'Aucun profil à classer',
    classifyAgain: 'Tout reclasser',
    classifyProfiles: 'Classer les profils',
    swipeToClassify: 'Swiper à droite ou à gauche pour définir le contact comme pro ou privé.',
    swipeClassifyInstruction:
      'Swiper à droite ou à gauche pour définir le contact comme pro ou privé.',
    import: 'Importer',
    importContacts: 'Import des contacts',
    importAll: 'Importer tout',
    allContactsImported: 'Tous les contacts ont été importés',
    pleaseSyncContacts: 'Veuillez synchroniser vos contacts',
    allImported: 'Tous les contacts ont été importés',
    syncContacts: 'Synchroniser mes contacts',
    selected: 'sélectionné',
    contactFound: 'Contact trouvé!',
    profileFound: 'Profil trouvé!',
    contactFoundScan: 'Contact trouvé!',
    profileFoundScan: 'Profil trouvé!',
  },
  profileScreen: {
    noLivingPlaceAdded: 'Aucun lieu de résidence ajouté',
    pressToAddFirstPlace: 'Appuyez sur + pour ajouter votre premier lieu',
    tapToAddFirstPlace: 'Appuyez sur + pour ajouter votre premier lieu',
    noDataAdded: 'Aucune donnée ajoutée',
    noAvailabilityAdded: 'Aucune disponibilité ajoutée',
    noContactInfoAdded: 'Aucune coordonnée ajoutée',
    noHashtagAdded: 'Aucun hashtag ajouté',
    backToMyProfile: 'Retour à mon profil',
    aboutSection: 'À propos :',
    uploadMemory: 'Télécharge ton souvenir :',
    selectMemory: 'Sélectionnez un souvenir',
    taggedContacts: 'Contacts identifiés',
    contactTagged: 'Contact identifié :',
    contactsTagged: 'Contacts identifiés :',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    currently: 'Actuellement',
    cityOrCountryName: 'Nom de la ville ou pays',
    duration: 'Durée',
    currentlyLivingHere: 'Je vis actuellement dans ce lieu',
  },
  notesScreen: {
    title: 'Notes',
    sharedNote: 'Note partagée',
    personalNote: 'Note personnelle',
    shared: 'partagée',
    personal: 'perso',
    allNotes: 'Toutes',
    searchPeople: 'Rechercher une personne',
    searchNotes: 'Rechercher dans les notes',
  },
  scheduledMessagesScreen: {
    private: 'Privé',
    pro: 'Pro',
    groups: 'Groupes',
    categoriesTab: 'Catégories',
    title: 'Messages programmés',
    results: '{count} résultats',
    scheduledFor: 'Programmé pour {time}',
    editing: 'Modifiez le message ci-dessous',
    deleteConfirm: 'ce message programmé',
    createMessage: 'Créer un message',
    loadError: 'Impossible de charger vos messages programmés.',
    chooseRecipient: 'Choisir un destinataire',
    typeMessage: 'Écrire un message',
    deleteScheduledMessage: 'Supprimer le message programmé',
  },
  hashtagsScreen: {
    notFound: 'Hashtag non trouvé',
    newHashtag: 'Nouveau hashtag',
    person: '{count} personne',
    persons: '{count} personnes',
    results: '{count} résultat',
    resultsPlural: '{count} résultats',
  },
  relationalColorsScreen: {
    title: 'Couleurs relationnelles',
    notFound: 'Couleur associée non trouvée',
    person: '{count} personne',
    persons: '{count} personnes',
    results: '{count} résultat',
    resultsPlural: '{count} résultats',
  },
  categoriesScreen: {
    title: 'Catégories',
    addSubcategory: 'Ajouter une sous-catégorie',
    subcategoryPhoto: 'Photo de la sous-catégorie',
    subcategoryPlaceholder: 'Titre de la sous-catégorie...',
    categoryPhoto: 'Photo de la catégorie',
    newCategory: 'Nouvelle catégorie',
    categoryTitlePlaceholder: 'Titre de la catégorie...',
    addCategory: 'Ajouter une catégorie',
    addSubcategoryWithPhoto: 'Ajouter une sous-catégorie',
    person: '{count} personne',
    persons: '{count} personnes',
    backToList: 'Retour à la liste des catégories',
    categoryContacts: 'Dans la catégorie',
  },
  notificationsScreen: {
    toAddPeople: 'pour ajouter des personnes',
    acceptAsPro: 'Accepter en tant que pro',
    acceptAsPrivate: 'Accepter en tant que privé',
    accept: 'Accepter',
  },
  notifications: {
    friendRequest: 'Demande de contact',
    acceptedRequest: 'Demande acceptée',
    rejectedRequest: 'Demande refusée',
    upcomingEvent: 'Événement à venir',
    contactReminder: 'Rappel Keep in touch',
    scheduledMessage: 'Message programmé',
    birthday: 'Anniversaire',
    eventReminder: "Rappel d'événement",
    syncContacts: 'Synchroniser mes contacts',
    toAddPeople: 'Pour ajouter des personnes',
    all: 'Tout',
    requests: 'Demandes',
    agenda: 'Agenda',
    accept: 'Accepter',
    reject: 'Refuser',
    accepted: 'Accepté',
    rejected: 'Refusé',
    acceptAsPro: 'Accepter en tant que pro',
    acceptAsPrivate: 'Accepter en tant que privé',
    orRejectRequest: 'Ou refuser la demande',
    requestGone: "Cette demande n'est plus disponible.",
    sentRequests: 'Demandes envoyées',
    receivedRequests: 'Demandes reçues',
    sections: {
      today: "Aujourd'hui",
      tomorrow: 'Demain',
      thisWeek: 'Cette semaine',
      earlier: 'Plus tôt',
    },
    empty: {
      title: 'Tout est à jour',
      subtitle: "Vous n'avez aucune notification pour le moment.",
    },
    loadError: {
      title: 'Impossible de charger vos notifications',
      subtitle: 'Vérifiez votre connexion, puis réessayez.',
      retry: 'Réessayer',
      stale: "Cette liste n'est peut-être pas à jour.",
    },
    markAllRead: 'Tout marquer comme lu',
    markAllReadShort: 'Tout lu',
    ago: 'il y a {time}',
    justNow: "à l'instant",
    titles: {
      keepContact: 'Garder contact avec {name}',
      request: '{name} souhaite vous ajouter à ses contacts',
      birthdayAge: "{name} fête ses {age} ans aujourd'hui",
      birthday: "C'est l'anniversaire de {name} aujourd'hui",
      scheduledMessage: 'Message programmé pour {name}',
      event: 'Rendez-vous',
      birthdayTomorrowAge: 'Demain, {name} fête ses {age} ans',
      birthdayTomorrow: 'Demain, {name} fête son anniversaire',
      accepted: '{name} a accepté votre demande de contact',
      acceptedByMe: '{name} fait maintenant partie de vos contacts {scope}',
      sent: 'Votre message programmé est parti chez {name}',
      sentGroup: 'Votre message programmé est parti dans le groupe {name}',
      done: "C'est noté ! Vous avez pris des nouvelles {de}{name}",
    },
    when: {
      today: "Aujourd'hui",
      tomorrow: 'Demain',
      todayAt: "Aujourd'hui à {time}",
      tomorrowAt: 'Demain à {time}',
      dayAt: '{day} à {time}',
      late: "{count, plural, one {En retard d'un jour} other {En retard de {count} jours}}",
    },
    lastMessage: 'dernier message {ago}',
    actions: {
      write: 'Écrire',
      postpone: 'Reporter',
      wish: 'Lui souhaiter',
      seeEvent: 'Voir le rendez-vous',
      seeProfile: 'Voir son profil',
      seeCard: 'Voir sa fiche',
      edit: 'Modifier',
      acceptPrivate: 'Accepter en privé',
      acceptPro: 'Accepter en pro',
      reject: 'Refuser',
      done: "C'est fait",
      undo: 'Annuler',
      route: 'Itinéraire',
      warnLate: "Prévenir d'un retard",
      call: 'Appeler',
      sms: 'Envoyer un SMS',
      email: 'Envoyer un e-mail',
      scheduleWish: 'Programmer mes vœux',
      editWish: 'Modifier mes vœux',
      seeConversation: 'Voir la conversation',
    },
    postpone: {
      title: 'Me le rappeler',
      tomorrow: 'Demain',
      in3Days: 'Dans 3 jours',
      inAWeek: 'Dans 1 semaine',
      inAMonth: 'Dans 1 mois',
      pickDate: 'Choisir une date…',
    },
    later: {
      keepContacts: '{count, plural, one {{count} suivi} other {{count} suivis}}',
      calendarEvents: '{count, plural, one {{count} rendez-vous} other {{count} rendez-vous}}',
      scheduledMessages: '{count, plural, one {{count} message programmé} other {{count} messages programmés}}',
      line: 'Prévu plus tard : {items}.',
      seeKeepContacts: 'Voir mes suivis',
      seeCalendar: 'Voir mes rendez-vous',
    },
    details: {
      eve: 'Préparez vos vœux maintenant : ils partiront demain à {time}.',
      eveScheduled: 'Vos vœux partiront demain à {time}.',
      eveGhost: "Fiche sans compte KeepTouch : pensez à l'appeler demain.",
      ghostPhone: "Fiche sans compte KeepTouch : pas de message dans l'app, mais son numéro est enregistré.",
      ghostNoPhone: 'Fiche sans compte KeepTouch.',
      acceptedScope: 'Vous êtes maintenant en contact ({scope}).',
      acceptedNoScope: 'Vous êtes maintenant en contact.',
      mutual:
        '{count, plural, one {1 contact en commun : {names}} other {{count} contacts en commun : {names}}}',
      nextReminder: 'Prochain rappel : {day}',
      finished: 'Ce suivi est terminé.',
      lateMessage: "Désolé, j'ai un petit retard, j'arrive dès que possible.",
      warnWho: 'Prévenir qui ?',
    },
    scope: {
      PRIVATE: 'Privé',
      PROFESSIONAL: 'Pro',
    },
    toasts: {
      wishScheduled: 'Vœux programmés pour demain à {time}',
      settingsSaved: 'Réglages enregistrés',
    },
  },
  notificationSettings: {
    title: 'Réglages des notifications',
    sectionPhone: 'Me prévenir sur mon téléphone',
    sectionQuiet: 'Être moins dérangé',
    keepContact: 'Garder contact',
    birthdays: 'Anniversaires',
    events: 'Rendez-vous',
    messages: 'Nouveaux messages',
    requests: 'Demandes de contact',
    morningDigest: 'Résumé du matin',
    quietHours: 'Ne pas déranger',
    digestNote:
      'Un seul résumé le matin (« 1 anniversaire, 2 personnes à recontacter ») à la place de plusieurs notifications.',
    digestDelayed: "Avec « Ne pas déranger » jusqu'à {hour}, le résumé arrive à {hour}.",
    quietNote: 'La nuit, les rappels attendent le matin.',
    choices: {
      keepContact: {
        onTime: "À l'heure prévue",
        morning: 'Le jour prévu, à 9:00',
        off: 'Jamais',
      },
      birthdays: {
        eveAndDay: 'La veille et le jour J',
        day: 'Le jour J',
        off: 'Jamais',
      },
      events: {
        '15': '15 minutes avant',
        '30': '30 minutes avant',
        '60': '1 heure avant',
        '120': '2 heures avant',
        off: 'Jamais',
      },
      live: {
        always: 'Toujours',
        exceptNight: 'Sauf la nuit',
        off: 'Jamais',
      },
      morningDigest: {
        off: 'Non',
        '7': 'Chaque jour à 7:00',
        '8': 'Chaque jour à 8:00',
        '9': 'Chaque jour à 9:00',
      },
      quietHours: {
        off: 'Désactivé',
        '21-7': 'De 21:00 à 7:00',
        '22-7': 'De 22:00 à 7:00',
        '22-8': 'De 22:00 à 8:00',
        '23-7': 'De 23:00 à 7:00',
        '23-8': 'De 23:00 à 8:00',
      },
    },
    open: 'Réglages des notifications',
  },
  mapScreen: {
    title: 'Carte',
    contactFound: '{count} contact trouvé dans cette zone',
    contactsFound: '{count} contacts trouvés dans cette zone',
    contactsFoundInZone:
      '{count, plural, =0 {Aucun contact sur la carte} one {{count} contact sur la carte} other {{count} contacts sur la carte}}',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    zoomLevel: 'Niveau de zoom',
    me: 'Moi',
    myPosition: 'Vous êtes ici',
    locateMe: 'Me localiser',
    myPositionHidden: 'Vous êtes ici (invisible pour vos contacts)',
    hideMe: 'Me rendre invisible sur la carte de mes contacts',
    showMe: 'Me rendre visible sur la carte de mes contacts',
    nowHidden: 'Vous êtes invisible sur la carte de vos contacts',
    nowVisible: 'Vous êtes visible sur la carte de vos contacts',
    nowVisiblePro: 'Vous êtes visible sur la carte de vos relations professionnelles',
    nowVisiblePrivate: 'Vous êtes visible sur la carte de vos relations privées',
  },
  birthdaysScreen: {
    title: 'Anniversaires',
    upcoming: 'Anniversaires à venir',
    private: 'Privé',
    pro: 'Pro',
    noBirthday: 'Aucun anniversaire',
    // Wish pre-filled in the conversation when the AI can't write one.
    wish: {
      opening: 'Joyeux anniversaire {firstName} !',
      openingEarly: 'Joyeux anniversaire en avance, {firstName} !',
      openingBelated: 'Joyeux anniversaire avec un peu de retard, {firstName} !',
      milestone: '{age} ans, ça se fête !',
      private: 'Passe une super journée ! 🎂',
      privateBelated: "J'espère que tu as passé une super journée ! 🎂",
      pro: 'Je vous souhaite une excellente journée.',
      proBelated: "J'espère que vous avez passé une excellente journée.",
    },
  },
  keepContactScreen: {
    private: 'Privée',
    pro: 'Pro',
  },
  qrCodeScreen: {
    shareProfile: 'Partager le profil',
    copyLink: 'Copier le lien',
    download: 'Télécharger',
  },
  webFooter: {
    legalNotice: 'Mentions légales',
    contactUs: 'Nous contacter',
    privacyPolicy: 'Charte de confidentialité',
    joinUs: 'Nous rejoindre',
  },
  legalNotice: {
    editor: 'Éditeur',
    editorContent:
      "KeepTouch SAS\nCapital social : 10 000 €\nSiège social : Paris, France\nDirecteur de la publication : Équipe KeepTouch",
    hosting: 'Hébergement',
    hostingContent:
      "Le site web est servi par Netlify. Les serveurs de l'application sont hébergés par Google Cloud (Cloud Run).",
    intellectualProperty: 'Propriété intellectuelle',
    intellectualPropertyContent:
      "L'ensemble du contenu de l'application KeepTouch (textes, images, logos, icônes, logiciels) est la propriété exclusive de KeepTouch SAS et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation ou diffusion sans autorisation écrite préalable est interdite.",
    liability: 'Responsabilité',
    liabilityContent:
      "KeepTouch SAS s'efforce de fournir des informations exactes et à jour. Toutefois, elle ne peut garantir l'exactitude, l'exhaustivité ou l'actualité des informations disponibles sur l'application. KeepTouch SAS ne saurait être tenue responsable de tout dommage direct ou indirect résultant de l'utilisation de l'application.",
  },
  contactUs: {
    description:
      "Vous avez une question, une suggestion ou besoin d'assistance ? N'hésitez pas à nous contacter. Notre équipe vous répondra dans les meilleurs délais.",
    emailLabel: 'Email',
    email: 'contact@keeptouch.app',
    addressLabel: 'Adresse',
    address: 'KeepTouch SAS\nParis, France',
  },
  privacyPolicy: {
    introduction:
      "KeepTouch s'engage à protéger la vie privée et les données personnelles de ses utilisateurs. Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos informations.",
    dataCollection: 'Collecte des données',
    dataCollectionContent:
      "Nous collectons les données que vous fournissez volontairement lors de la création de votre compte et de l'utilisation de l'application : nom, adresse email, contacts, notes, rappels et toute autre information que vous choisissez de partager.",
    dataUsage: 'Utilisation des données',
    dataUsageContent:
      'Vos données sont utilisées exclusivement pour fournir et améliorer le service KeepTouch. Nous ne vendons ni ne partageons vos données personnelles avec des tiers à des fins marketing.',
    dataProtection: 'Protection des données',
    dataProtectionContent:
      'Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès, modification, divulgation ou destruction non autorisés.',
    cookies: 'Cookies',
    cookiesContent:
      "L'application peut utiliser des cookies et technologies similaires pour améliorer l'expérience utilisateur et analyser l'utilisation. Vous pouvez gérer vos préférences en matière de cookies à tout moment depuis vos paramètres.",
    rights: 'Vos droits',
    rightsContent:
      "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données personnelles. Vous avez également le droit de limiter et de vous opposer au traitement de vos données. Pour exercer ces droits, contactez-nous à : contact@keeptouch.app",
    // BROUILLON — section « Événements » à faire relire par un juriste avant mise en production
    // (voir docs/rgpd/points-a-valider-juriste.md dans l'API).
    eventsTitle: 'Événements',
    eventsIntro:
      "Cette section s’applique lorsque vous vous inscrivez à un événement organisé avec KeepTouch (lien, QR code ou invitation). KeepTouch est responsable de la liste des participants dans l’application. L’organisateur reçoit une partie de ces données pour gérer son événement et est responsable de l’usage qu’il en fait.",
    eventsData: 'Données concernées',
    eventsDataContent:
      "Selon votre façon de vous inscrire : prénom, nom, adresse email, poste et entreprise (formulaire) ; ou, avec LinkedIn, votre nom, votre email vérifié, votre photo et la langue de votre compte LinkedIn (les informations brutes renvoyées par LinkedIn sont conservées dans votre profil KeepTouch). Si vous avez déjà un compte KeepTouch, votre profil (poste, entreprise, photo, lien LinkedIn) est utilisé. S’ajoutent : la date et le mode d’inscription, votre présence si l’organisateur la pointe à l’entrée et, pour un événement payant, le paiement (montant, date, statut).",
    eventsPurposes: 'À quoi servent ces données',
    eventsPurposesContent:
      "Vous inscrire et vous envoyer votre code de connexion et la confirmation d’inscription ; montrer la liste des participants aux autres inscrits pour que chacun puisse garder le contact ; permettre à un participant de vous ajouter directement à ses contacts, avec le nom de l’événement comme lieu de rencontre ; permettre à l’organisateur de gérer son événement (liste, pointage à l’entrée, export) ; vous écrire à la fin de l’événement (les personnes rencontrées) ; traiter le paiement d’un billet.",
    eventsLegalBasis: 'Pourquoi nous avons le droit de les utiliser',
    eventsLegalBasisContent:
      "L’exécution du service que vous demandez : votre inscription et la mise en relation avec les autres participants. Votre inscription vaut acceptation d’apparaître dans la liste, et vous pouvez la retirer à tout moment en vous désinscrivant. L’intérêt légitime de KeepTouch et de l’organisateur à gérer l’événement (liste, pointage, sécurité). L’obligation légale de conserver les paiements pour la comptabilité.",
    eventsRecipients: 'Qui voit vos données',
    eventsRecipientsContent:
      "Les autres inscrits, dès votre inscription : votre prénom, nom, poste, entreprise, photo et lien LinkedIn. Jamais votre email ni vos notes. Toute personne qui a le lien ou le QR code de l’événement : seulement les prénoms et photos des participants, tant que la page publique est ouverte. L’organisateur : votre nom, poste, entreprise, email, présence et, s’il y en a un, votre paiement ; il peut exporter la liste ; il ne voit jamais vos notes. Un participant qui vous ajoute : votre fiche entre dans ses contacts, sans demande ni notification. Nos prestataires techniques, qui n’agissent que sur nos instructions : hébergement, envoi d’emails et, lorsque le paiement en ligne sera activé, prestataire de paiement. KeepTouch ne vend pas vos données.",
    eventsRetention: 'Durée de conservation',
    eventsRetentionContent:
      "La liste des participants, les invitations, la présence pointée et l’origine des rencontres d’un événement sont supprimées 24 mois après la fin de l’événement. Les personnes qui vous ont ajouté à leurs contacts et celles que vous avez ajoutées aux vôtres restent dans ces contacts : chaque contact appartient à celui qui l’a créé. Si vous supprimez votre compte, vous disparaissez des contacts des autres. Les paiements sont conservés 10 ans (obligation comptable) ; si vous supprimez votre compte, ils restent sans aucun lien avec vous. Si vous supprimez votre compte, vos données d’événements sont effacées immédiatement, à l’exception des paiements. Les codes de connexion reçus par email sont effacés au plus tard deux jours après leur expiration.",
    eventsInvitations: 'Invitations reçues par email',
    eventsInvitationsContent:
      "Lorsqu’un organisateur saisit votre adresse pour vous inviter, KeepTouch vous envoie une invitation qui indique qui vous invite et pour quel événement. Le lien « Ne plus recevoir d’invitations de KeepTouch » de cet email place votre adresse sur une liste d’opposition : vous ne recevrez plus aucune invitation de notre part.",
    eventsLinkedIn: 'Connexion avec LinkedIn',
    eventsLinkedInContent:
      "Nous ne recevons que ce que LinkedIn transmet pour la connexion : nom, email vérifié, photo, langue et identifiant LinkedIn. Nous ne publions rien sur LinkedIn et n’accédons ni à vos contacts ni à votre réseau. Vous pouvez retirer l’accès de KeepTouch depuis les paramètres de votre compte LinkedIn.",
    eventsRights: 'Vos droits et comment les exercer',
    eventsRightsContent:
      "Accès, rectification, effacement, opposition, limitation et portabilité. Vous pouvez : vous désinscrire d’un événement depuis la page de l’événement ; modifier votre profil depuis l’application ; supprimer votre compte depuis Paramètres > Supprimer mon compte (si votre compte n’a pas encore de mot de passe, créez-en un d’abord dans Paramètres) ; refuser les invitations avec le lien présent dans chaque invitation ; télécharger gratuitement une copie de vos données d’événements (inscriptions, présence, paiements, invitations reçues, contacts ajoutés via un événement, demandes d’organisateur), au format JSON ou tableur (CSV), depuis Paramètres > Exporter mes données d’événements. Pour toute autre demande, écrivez-nous : nous répondons dans un délai d’un mois. Vous pouvez aussi saisir la CNIL (cnil.fr).",
  },
  joinUs: {
    description:
      'KeepTouch est une application innovante dédiée à aider les gens à maintenir et renforcer leurs relations. Rejoignez notre équipe et contribuez à un projet qui fait la différence !',
    whyJoin: 'Pourquoi rejoindre KeepTouch ?',
    whyJoinContent:
      '• Travailler sur un projet innovant à impact social\n• Rejoindre une équipe passionnée et dynamique\n• Environnement de travail flexible et télétravail possible\n• Opportunités de croissance et de développement',
    positions: 'Postes ouverts',
    positionsContent:
      'Nous sommes toujours à la recherche de talents pour rejoindre notre équipe. Les postes actuellement ouverts incluent :\n\n• Développeur Full-Stack (React Native / NestJS)\n• Designer UX/UI\n• Responsable Marketing & Growth\n• Community Manager',
    apply: 'Comment postuler',
    applyEmail: 'jobs@keeptouch.app',
  },
  emotionalContexts: {
    'affection-intimite': {
      name: 'Affection & Intimité',
      description: 'Ces contacts nourrissent ton cœur.',
    },
    'aspiration-inspiration': {
      name: 'Aspiration & Inspiration',
      description: 'Ces contacts te tirent vers le haut.',
    },
    'stimulation-aventure': {
      name: 'Stimulation & Aventure',
      description: 'Ces contacts mettent du mouvement et de la folie dans ta vie.',
    },
    'soutien-stabilite': {
      name: 'Soutien & Stabilité',
      description: 'Ces contacts te soutiennent émotionnellement et te structurent.',
    },
    'reflexion-profondeur': {
      name: 'Réflexion & Profondeur',
      description: "Ces contacts t'aident à penser, te comprendre, évoluer.",
    },
    'lacher-prise-detente': {
      name: 'Lâcher-prise & Détente',
      description: "Ces contacts t'aident à respirer, décrocher, exister sans pression.",
    },
    affection: 'Affection',
    'joie-chaleureuse': 'Joie chaleureuse',
    'tendre-complicite': 'Tendre complicité',
    'presence-reconfortante': 'Présence réconfortante',
    'partage-authentique': 'Partage authentique',
    aspiration: 'Aspiration',
    motivation: 'Motivation',
    source: 'Source',
    'elan-creatif': 'Élan créatif',
    'grandeur-ame': "Grandeur d'âme",
    stimulation: 'Stimulation',
    aventure: 'Aventure',
    exploration: 'Exploration',
    'adrenaline-partagee': 'Adrénaline partagée',
    fun: 'Fun',
    soutien: 'Soutien',
    encouragement: 'Encouragement',
    securite: 'Sécurité',
    apaisement: 'Apaisement',
    'croissance-lente': 'Croissance lente',
    apprentissage: 'Apprentissage',
    comprehension: 'Compréhension',
    miroir: 'Miroir',
    'conscience-soi': 'Conscience de soi',
    'conversations-vraies': 'Conversations vraies',
    detente: 'Détente',
    legerete: 'Légèreté',
    'presence-sans-enjeu': 'Présence sans enjeu',
    rire: 'Rire',
    instantaneite: 'Instantanéité',
  },
  meetingContexts: {
    'ecole-universite': 'École / Université',
    travail: 'Travail',
    'evenement-pro': 'Événement pro',
    'evenement-social': 'Événement social',
    'amis-connaissance': 'Amis / Connaissance',
    voyage: 'Voyage',
    'sport-activite': 'Sport / Activité',
    'en-ligne': 'En ligne',
    dating: 'Dating',
    famille: 'Famille',
  },
  rrule: {
    custom: 'Personnalisée',
  },
  relationshipStatus: {
    growing: 'En croissance',
    stable: 'Stable',
    to_reconnect: 'À recontacter',
    fluctuating: 'Fluctuante',
    declining: 'En décroissance',
    ended: 'Terminé',
  },
  nearby: {
    headerTitle: 'À proximité',
    pageTitle: 'Contacts à proximité',
    perimeter10: 'Profils à moins de 10 km',
    perimeter50: 'Profils à moins de 50 km',
    perimeter100: 'Profils à moins de 100 km',
    perimeter10Short: 'À moins de 10 km',
    perimeter50Short: 'À moins de 50 km',
    perimeter100Short: 'À moins de 100 km',
    perimeterLabel: 'Périmètres',
    visibilityAll: 'Vous êtes actuellement visible pour tous les utilisateurs.',
    visibilityProfessional: 'Vous êtes actuellement visible pour vos relations professionnelles.',
    visibilityPrivate: 'Vous êtes actuellement visible pour vos relations privées.',
    visibilityHidden: "Vous n'êtes actuellement visible pour personne à proximité.",
    visibilityAllMobile: 'Visible pour tous les utilisateurs.',
    visibilityProfessionalMobile: 'Visible pour vos relations professionnelles.',
    visibilityPrivateMobile: 'Visible pour vos relations privées.',
    visibilityHiddenMobile: 'Visible pour personne.',
    visibilityLoading: 'Chargement de votre visibilité...',
    editVisibility: 'Modifier ma visibilité',
    filterPrivate: 'Privé',
    filterPro: 'Pro',
    emptyNoResults: 'Aucun résultat.',
    emptyNoContacts: 'Aucun contact trouvé à proximité.',
    groupLabel: 'Les profils à moins de {distance} km !',
    visibilityOptionAllTitle: 'Pro & Privé',
    visibilityOptionAllDescription:
      'Votre profil est visible par tous les utilisateurs (professionnels et privés).',
    visibilityOptionProTitle: 'Pro',
    visibilityOptionProDescription: 'Visible uniquement par les professionnels et entreprises.',
    visibilityOptionPrivateTitle: 'Privé',
    visibilityOptionPrivateDescription: 'Visible uniquement par les utilisateurs privés.',
    visibilityOptionHiddenTitle: 'Ne pas être visible',
    visibilityOptionHiddenDescription: "Votre profil n'apparaît pour personne à proximité.",
    modalTitle: 'Modifier ma visibilité',
    modalSubtitle: 'Choisissez qui peut voir votre profil sur KeepTouch',
    modalHint: 'Cochez une ou plusieurs options selon vos besoins.',
    updateButton: 'Mettre à jour la visibilité',
    scopePrivate: 'Privé',
    scopePro: 'Pro',
    noPosition:
      "Votre position n'est pas encore connue. Autorisez la localisation sur cet appareil pour voir vos contacts à proximité.",
    noPositionHidden:
      "Vous êtes invisible : votre position n'est pas enregistrée, la liste ne peut donc pas être calculée.",
    loadError: 'Une erreur est survenue. Réessayez.',
    visibilityUnknown: "Votre visibilité n'a pas pu être chargée.",
  },
  ai: {
    assistant: 'Assistant IA',
    tabSuggest: 'Suggérer',
    tabSummarize: 'Résumer',
    tabAnalyze: 'Analyser',
    generateSuggestions: 'Générer des suggestions',
    use: 'Utiliser',
    summaryInProgress: 'Résumé en cours...',
    analysisInProgress: 'Analyse en cours...',
    sentiment: 'Sentiment',
    sentimentUndetermined: 'Non déterminé',
    topics: 'Sujets abordés',
    dynamics: 'Dynamique',
    keyPoints: 'Points clés',
    errorRetry: 'Une erreur est survenue. Réessayez.',
    instructionsPlaceholder: "Instructions (optionnel) : ex. 'ton formel', 'propose un rdv'...",
    generatedByAi: "Message généré par l'IA",
  },
  scheduledMessage: {
    create: {
      reasonQuestion: 'Quelle est la raison du message ?',
      writeManually: 'Écrire moi-même',
      recipientBadge: 'Pour',
      reasonBadge: 'Raison',
      additionalDetailsPlaceholder: 'Ex: Il vient de décrocher un nouveau poste...',
      messageForContact: 'Message pour {name}',
      additionalDetails: 'Détails supplémentaires (optionnel)',
      scheduledFor: '{date} à {time}',
      reasons: {
        birthday: 'Anniversaire',
        reconnect: 'Reprendre contact',
        congratulations: 'Félicitations',
        thank_you: 'Remerciement',
        check_in: 'Prendre des nouvelles',
        new_year: 'Bonne année / Fêtes',
        encouragement: 'Encouragement',
        other: 'Autre',
      },
      generateWithAi: "Générer avec l'IA",
      generating: 'Génération...',
      regenerate: 'Régénérer',
      regenerating: 'Régénération...',
      writeYourMessage: 'Écrire votre message',
      reviewAndSend: 'Vérifier et envoyer',
      generateFailedTitle: "L'IA n'a pas pu écrire le message",
      generateFailedMessage: 'Réessayez, ou écrivez-le vous-même.',
    },
    schedule: {
      programButton: 'Programmer',
    },
  },
  cardScan: {
    awaitingCamera: 'En attente de la caméra...',
    allowCamera: 'Autoriser la caméra',
    retake: 'Reprendre',
    analyze: 'Analyser',
    dragDropPhoto: 'Glissez-déposez une photo de carte de visite ici',
    orClickToSelect: 'ou cliquez pour sélectionner un fichier',
  },
  qrCodeScan: {
    title: 'Scanner un Code QR',
    headerTitle: 'QR Code',
  },
  ghostForm: {
    tagsSection: 'Tags',
    pinsSection: 'Pins',
    organizeProfile: 'Ranger le profil',
    hashtagPlaceholder: 'Nom du #...',
    goalPlaceholder: 'Construire une maison...',
    profileHashtagsName: 'Hashtag du profile',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
  },
  notes: {
    empty: {
      titleShared: 'Aucune note "partagée"',
      titlePersonal: 'Aucune note "perso"',
      pressPlusToCreate: 'Appuyez sur + pour créer votre première note',
      noMatch: 'Aucune note ne correspond à cette recherche',
    },
    loadError: {
      title: 'Impossible de charger les notes',
      subtitle: 'Vérifiez votre connexion, puis réessayez.',
      partial: "Toutes les notes n'ont pas pu être chargées.",
    },
    sections: {
      pinned: 'Épinglées',
      today: "Aujourd'hui",
      thisWeek: 'Cette semaine',
    },
    dates: {
      today: "Aujourd'hui",
      yesterday: 'Hier',
    },
    sharedBy: 'Partagée par {name}',
    readOnly: "Seule la personne qui l'a écrite peut la modifier.",
    summaryTitle: 'Ce que je sais de {name}',
    summaryFootnote: "Résumé fait par l'Assistant IA à partir de tes notes",
    toRemember: 'À retenir :',
    historyTitle: 'Historique avec {name}',
    history: {
      note: 'Note',
      message: 'Message',
      event: 'Rendez-vous',
      keepContact: 'Rappel',
      line: '{type} · ',
    },
    source: {
      assistant: 'Assistant IA',
      voice: 'Dictée',
    },
    dictateNote: 'Dicter une note',
    stopRecording: 'Arrêter · {time}',
  },
  editCategory: {
    title: 'Modifier une catégorie',
    deleteConfirm: 'cette catégorie',
  },
  editHashtag: {
    deleteConfirm: 'ce hashtag',
  },
  editNote: {
    deleteConfirm: 'cette note',
    saved: 'Enregistré',
    saving: 'Enregistrement…',
    close: 'Fermer',
    notSaved: 'Non enregistré',
    notSavedTitle: 'Note non enregistrée',
    notSavedMessage: "Cette note n'a pas pu être enregistrée. Vérifiez votre connexion, puis réessayez.",
    retry: 'Réessayer',
    leaveWithoutSaving: 'Quitter sans enregistrer',
    keepEditing: 'Rester sur la note',
  },
  ghostProfileExtra: {
    amisEnCommun: 'Amis en commun',
    inContactWith: 'En contact avec {names}',
  },
  formExtra: {
    selectTime: 'Sélectionner une heure',
    yourMessage: 'Votre message...',
    chooseTime: "Choisir l'heure",
    cancel: 'Annuler',
  },
  filterHeader: {
    clear: 'Effacer',
  },
  messagesPinned: {
    label: 'Épinglés',
  },
  translate: {
    toggle: 'Traduire',
    original: 'Texte original',
    lang: {
      fr: 'Français',
      en: 'Anglais',
      es: 'Espagnol',
    },
  },
  mergeSuggestions: {
    ghostBadge: 'Fantôme',
    realBadge: 'Contact réel',
    reason: {
      FullName: 'Nom complet identique',
      LastName: 'Nom de famille identique',
      FirstName: 'Prénom identique',
      Email: 'Email identique',
      Phone: 'Téléphone identique',
      LinkedIn: 'LinkedIn identique',
      Instagram: 'Instagram identique',
      Facebook: 'Facebook identique',
      Twitter: 'Twitter identique',
    },
    confirmTitle: 'Fusionner ces deux fiches ?',
    confirmKept: '« {ghost} » (fiche que vous avez créée) va être fusionnée dans le contact {real}. Ses notes, rappels, messages programmés, catégories, hashtags et couleurs passent sur {real}. Les informations saisies sur la fiche (téléphone, e-mail, anniversaire, métier, rendez-vous…) sont gardées dans une note privée. La photo et la fiche elle-même sont supprimées. Cette action est définitive.',
    confirmLost: '« {ghost} » (fiche que vous avez créée) va être fusionnée dans le contact {real}. Ses notes, rappels, messages programmés, catégories, hashtags et couleurs passent sur {real}. Les informations saisies sur la fiche (téléphone, e-mail, anniversaire, photo…) seront effacées. Cette action est définitive.',
    confirmGhostPair: '« {ghost} » va être fusionnée dans votre autre fiche « {kept} ». Ses notes, rappels, rendez-vous, catégories, hashtags et couleurs passent sur la fiche gardée. Les informations qui manquent y sont ajoutées ; celles qui diffèrent sont gardées dans une note privée. La fiche en double est supprimée. Cette action est définitive.',
    done: 'Fiches fusionnées',
    doneNote: 'Les informations de la fiche sont dans une note sur {name}.',
    doneGhostNote: 'Les informations différentes sont dans une note sur {name}.',
    failed: "La fusion n'a pas pu être faite. Rien n'a été modifié.",
  },
  ftSocialImport: {
    title: 'Importer depuis un réseau social',
    chooseNetwork: 'Choisissez un réseau social',
    usernameLabel: "Nom d'utilisateur",
    linkedinNameLabel: 'Nom de la personne',
    startImport: "Lancer l'import",
    placeholder: {
      linkedin: 'Prénom Nom (ex: Jean Dupont)',
      facebook: 'URL ou username (ex: https://facebook.com/zuck)',
      twitter: 'URL ou username (ex: https://x.com/elonmusk)',
      instagram: "Nom d'utilisateur (ex: ethpas)",
      generic: "Nom d'utilisateur",
    },
    launched: {
      title: 'Import lancé',
      message:
        "L'import a été lancé. Vous pouvez suivre sa progression depuis la liste de contacts.",
      networkMessage: "L'import {network} a été lancé.",
    },
    error: {
      title: 'Erreur',
      startFailed: "Impossible de lancer l'import",
      validateFailed: 'Impossible de valider la sélection',
      genericError: 'Une erreur est survenue',
    },
    previousImports: 'Imports précédents',
    newImport: 'Nouvel import',
    inProgress: 'Import en cours…',
    failed: 'Échoué',
    alreadyAdded: 'Déjà ajouté',
    profilesFound: '{count, plural, one {# profil trouvé} other {# profils trouvés}}',
    networkDescription: {
      linkedin: 'Entrez le nom de la personne à recherchez',
      generic: 'Entrez le username {network} pour importer ses followers',
    },
    results: {
      title: 'Résultats — {network}',
      runningHint: 'Cela peut prendre quelques minutes',
      failedTitle: "L'import a échoué",
      selectAll: 'Tout sélectionner',
      deselectAll: 'Tout désélectionner',
      validate: 'Valider la sélection ({count})',
      successTitle: 'Succès',
      successMessage: '{count, plural, one {# profil importé} other {# profils importés}}',
      loadMore: 'Afficher la suite',
      shownOf: '{shown} affichés sur {total}',
      empty: 'Aucun profil à afficher pour cet import.',
      partial: '{count, plural, one {# profil a été ajouté} other {# profils ont été ajoutés}} avant cette erreur.',
    },
  },
  notFoundPage: {
    title: 'Page introuvable',
    message: "Cette adresse n'existe pas ou n'existe plus.",
    button: 'Retour à mes contacts',
    buttonLoggedOut: "Retour à l'accueil",
  },
  // --- Events POC ---
  createPassword: {
    title: "Créez votre mot de passe",
    subtitle: "Pour vous reconnecter plus tard avec votre email, sans attendre de code.",
    password: "Mot de passe",
    confirm: "Confirmez le mot de passe",
    rule: "{min} caractères minimum",
    mismatch: "Les deux mots de passe ne sont pas identiques.",
    save: "Enregistrer",
    later: "Plus tard",
    savedTitle: "Mot de passe créé",
    savedMessage: "Vous pouvez maintenant vous connecter avec votre email et ce mot de passe.",
    settingsTitle: "Mot de passe",
    settingsDescription: "Ce compte n'a pas encore de mot de passe : il se connecte avec un code reçu par email.",
    settingsButton: "Créer mon mot de passe",
  },
  loginWithCode: {
    title: "Connexion par code",
    subtitle: "Recevez un code à 6 chiffres par email : pas besoin de mot de passe.",
    link: "Se connecter avec un code reçu par email",
    withPassword: "Se connecter avec un mot de passe",
  },
  admin: {
    title: "Administration",
    forbidden: "Cet espace est réservé aux administrateurs KeepTouch.",
    denied: "Cet espace est réservé aux administrateurs KeepTouch.",
    home: {
      requests: "Demandes d’organisateurs",
      requestsHint: "Valider ou refuser les comptes qui veulent organiser des événements.",
      organizers: "Organisateurs",
      organizersHint: "Fixer la commission sur la billetterie de chaque organisateur.",
    },
    requests: {
      title: "Demandes en attente",
      empty: "Aucune demande en attente",
      emptyHint: "Les nouvelles demandes d’organisateurs apparaîtront ici.",
      organization: "Organisation",
      message: "Message",
      sentOn: "Demande envoyée le {date}",
      approve: "Valider",
      reject: "Refuser",
      rejectTitle: "Refuser la demande",
      rejectDescription: "{name} recevra un email avec le motif de votre refus.",
      rejectReasonLabel: "Motif du refus (obligatoire)",
      toast: {
        approved: "Organisateur validé",
        rejected: "Demande refusée",
      },
    },
    organizers: {
      title: "Organisateurs",
      searchPlaceholder: "Rechercher par nom ou email",
      empty: "Aucun organisateur trouvé",
      eventCount: "{count, plural, =0 {Aucun événement} one {# événement} other {# événements}}",
      validatedOn: "validé le {date}",
      add: "Ajouter un organisateur",
      active: "Actifs",
      removed: "Retirés",
      emptyRemoved: "Aucun organisateur retiré",
    },
    organizer: {
      title: "Organisateur",
      commissionTitle: "Commission sur la billetterie",
      commissionLabel: "Taux de commission (%, de 0 à 30)",
      commissionInvalid: "Saisissez un nombre entre 0 et 30 (exemple : 7,5).",
      noCommission: "Aucune commission",
      commissionSummary: "Commission de {rate} %",
      feePaidBy: "Frais payés par",
      feeAttendee: "Le participant",
      feeOrganizer: "L’organisateur",
      appliesToFuture: "S’applique aux prochains paiements uniquement.",
      save: "Enregistrer",
      billingUnavailable: "Le réglage de la commission n’est pas disponible pour le moment.",
      roleTitle: "Rôle organisateur",
      roleHint: "Retirer le rôle empêche de créer ou gérer des événements. Les événements existants sont conservés.",
      removeRole: "Retirer le rôle organisateur",
      removeConfirm: "Cette personne ne pourra plus créer ni gérer d’événements. Continuer ?",
      organizationTitle: "Organisation",
      organizationLabel: "Nom de l’organisation",
      organizationInvalid: "Indiquez un nom (2 caractères minimum).",
      saveName: "Enregistrer le nom",
      statsTitle: "Chiffres",
      statEvents: "Événements",
      statAttendees: "Inscrits",
      statPaid: "Total payé",
      statCommission: "Commission générée",
      eventsTitle: "Ses événements",
      noEvents: "Aucun événement pour l’instant.",
      removedTitle: "Rôle organisateur retiré",
      removedHint: "Cette personne ne peut plus créer ni gérer d’événements. Ses événements existants sont conservés.",
      reactivate: "Réactiver l’organisateur",
      toast: {
        saved: "Commission enregistrée",
        renamed: "Nom enregistré",
        reactivated: "Organisateur réactivé",
        removed: "Rôle organisateur retiré",
      },
    },
    nav: {
      overview: "Vue globale",
      requests: "Demandes",
      organizers: "Organisateurs",
      events: "Événements",
      settings: "Paramètres",
    },
    overview: {
      error: "Impossible de charger les chiffres pour le moment.",
      people: "Personnes",
      organizers: "Organisateurs actifs",
      requests: "Demandes en attente",
      requestsHint: "À valider ou refuser",
      attendees: "Inscrits confirmés",
      attendeesHint: "Places payées ou gratuites confirmées",
      checkedIn: "Présents pointés",
      checkedInHint: "Pointés à l’entrée",
      eventsTitle: "Événements",
      upcoming: "À venir",
      ongoing: "En cours",
      past: "Passés",
      ticketingTitle: "Billetterie",
      paid: "Total payé",
      paymentsCount: "{count, plural, =0 {Aucun paiement} one {# paiement} other {# paiements}}",
      commission: "Commission KeepTouch",
      net: "Net reversé aux organisateurs",
      netHint: "Après commission",
      paidOnly: "Seuls les paiements réussis sont comptés.",
      nextEvents: "Prochains événements",
      seeAllEvents: "Voir les événements",
      noNextEvents: "Aucun événement à venir.",
      latestRequests: "Dernières demandes",
      seeRequests: "Voir les demandes",
      noRequests: "Aucune demande pour l’instant.",
      status: {
        pending: "En attente",
        approved: "Validée",
        rejected: "Refusée",
      },
    },
    events: {
      title: "Événements",
      searchPlaceholder: "Rechercher un événement, un code ou un organisateur",
      phase: {
        upcoming: "À venir",
        ongoing: "En cours",
        ended: "Terminé",
      },
      noOrganizer: "Organisateur inconnu",
      attendees: "Inscrits",
      checkedIn: "Présents",
      price: "Prix",
      free: "Gratuit",
      paidTotal: "Total payé",
      empty: "Aucun événement ne correspond.",
      range: "{from}–{to} sur {total}",
      previous: "Précédent",
      next: "Suivant",
      pageOf: "Page {page} sur {pages}",
      period: "Période",
      periodFrom: "Du",
      periodTo: "Au",
      periodInvalid: "La date de début doit précéder la date de fin.",
      preset: {
        today: "Aujourd’hui",
        week: "Cette semaine",
        month: "Ce mois-ci",
        last30: "30 derniers jours",
      },
      statusLabel: "Statut",
      status: {
        upcoming: "À venir",
        ongoing: "En cours",
        ended: "Terminé",
      },
      pricingLabel: "Tarif",
      pricing: {
        free: "Gratuit",
        paid: "Payant",
      },
      categoryLabel: "Catégorie",
      formatLabel: "Format",
      organizerFilter: "Organisateur",
      anyOrganizer: "Tous les organisateurs",
      clearOrganizer: "Retirer le filtre organisateur",
      sortLabel: "Trier par",
      sort: {
        date: "Date",
        attendees: "Inscrits",
        paid: "Montant encaissé",
      },
      orderLabel: "Ordre",
      order: {
        asc: "Croissant",
        desc: "Décroissant",
      },
      total: "{count, plural, =0 {Aucun événement} one {# événement} other {# événements}}",
      clear: "Effacer les filtres",
      error: "Impossible de charger les événements (vérifiez la période).",
    },
    eventDetail: {
      title: "Événement",
      notFound: "Cet événement est introuvable.",
      code: "Code",
      publicPage: "Ouvrir la page publique",
      figures: "Chiffres",
      capacity: "Places",
      unlimited: "Illimitées",
      payments: "Paiements",
      information: "Informations",
      organizer: "Organisateur",
      starts: "Début",
      ends: "Fin",
      registrationCloses: "Fin des inscriptions",
      format: "Format",
      formats: {
        in_person: "Sur place",
        online: "En ligne",
        hybrid: "Sur place et en ligne",
      },
      place: "Lieu",
      onlineUrl: "Lien de connexion",
      contact: "Contact",
      createdOn: "Créé le",
    },
    settings: {
      title: "Paramètres",
      error: "Impossible de charger les paramètres pour le moment.",
      commissionTitle: "Commission par défaut",
      commissionHint: "Appliquée aux organisateurs qui n’ont pas de réglage propre. Vous pouvez toujours fixer un taux différent sur la fiche d’un organisateur.",
      serverValue: "Valeur du serveur, jamais modifiée.",
      ownSettingWins: "Le réglage propre à un organisateur reste prioritaire.",
      historyTitle: "Historique des modifications",
      historyEmpty: "Aucune modification enregistrée.",
      changedBy: "Modifié par {name} le {date}",
      unknownAdmin: "un administrateur",
      toast: {
        saved: "Paramètres enregistrés",
      },
    },
    add: {
      title: "Ajouter un organisateur",
      searchTitle: "Un compte existant",
      searchHint: "Cherchez par nom ou par email parmi tous les comptes KeepTouch.",
      searchPlaceholder: "Nom ou email",
      noAccount: "Aucun compte ne correspond. Invitez cette personne par email ci-dessous.",
      alreadyOrganizer: "Déjà organisateur",
      give: "Donner le rôle organisateur",
      organizationLabel: "Nom de l’organisation (facultatif)",
      rateLabel: "Commission en % (facultatif)",
      defaultHint: "Sans réglage, la commission par défaut de la plateforme s’applique. Un email « compte organisateur activé » est envoyé.",
      inviteTitle: "Pas encore de compte ?",
      inviteHint: "La personne reçoit un email avec un lien vers l’inscription. Dès qu’elle a un compte, elle est organisatrice automatiquement.",
      emailLabel: "Adresse email",
      emailInvalid: "Saisissez une adresse email valide.",
      invite: "Inviter par email",
      accountExists: "Cette adresse a déjà un compte KeepTouch. Vous pouvez lui donner directement le rôle.",
      pendingTitle: "Invitations en attente",
      pendingEmpty: "Aucune invitation en attente.",
      pendingRate: "commission {rate} %",
      pendingSince: "invitée le {date} par {name}",
      pendingExpiresOn: "Expire le {date}",
      pendingExpired: "Expirée",
      cancelInvitation: "Annuler",
      resendInvitation: "Renvoyer",
      toast: {
        given: "Rôle organisateur donné",
        invited: "Invitation envoyée",
        cancelled: "Invitation annulée",
      },
    },
    request: {
      blockTitle: "Vous organisez des événements ?",
      blockHint: "Demandez un compte organisateur pour créer vos événements et inviter vos participants. Chaque demande est validée par l’équipe KeepTouch.",
      cta: "Devenir organisateur",
      retry: "Faire une nouvelle demande",
      rejected: "Demande refusée : {reason}",
      pendingTitle: "Demande envoyée, en attente de validation",
      pendingHint: "Votre demande pour « {name} » est en cours d’examen. Vous recevrez un email dès qu’elle sera traitée.",
      formTitle: "Devenir organisateur",
      formIntro: "Présentez-nous votre activité. Nous examinons votre demande et vous répondons par email.",
      organizationLabel: "Organisation ou nom de l’événement",
      organizationError: "Indiquez le nom de votre organisation (2 caractères minimum).",
      messageLabel: "Parlez-nous de vos événements",
      messageError: "Décrivez brièvement les événements que vous organisez.",
      websiteLabel: "Site web (facultatif)",
      websiteError: "Saisissez une adresse commençant par http:// ou https://.",
      send: "Envoyer ma demande",
      toast: {
        sentTitle: "Demande envoyée",
        sentMessage: "Nous revenons vers vous par email.",
      },
    },
  },
  events: {
    checkin: {
      title: "Accueil",
      startTitle: "Accueil de l’événement",
      startHint: "Facultatif. Pointez les arrivants à l’entrée : ceux qui n’ont pas pu venir recevront un récap des personnes présentes.",
      start: "Lancer l’accueil",
      counter: "{present, plural, =0 {présent} one {présent} other {présents}} sur {total} {total, plural, =0 {inscrit} one {inscrit} other {inscrits}}",
      present: "Présent",
      absent: "Absent",
      empty: "Aucun inscrit pour l’instant.",
      noResult: "Aucun participant ne correspond.",
      scan: {
        headerTitle: "Scanner",
        instruction: "Visez le QR code du participant (son QR personnel, ou le QR de son billet).",
        manualLabel: "Coller le contenu du QR",
        manualPlaceholder: "https://keeptouch.co/profile/…",
        manualSubmit: "Valider",
        cameraUnavailable: "Caméra indisponible. Collez le contenu du QR ci-dessous.",
        checkedInTitle: "{name} — présent",
        alreadyTitle: "{name} — déjà pointé à {time}",
        alreadyTitleOtherDevice: "{name} — déjà pointé à {time} par un autre appareil",
        notRegisteredTitle: "Pas inscrit à cet événement",
        wrongEventTitle: "Billet d’un autre événement",
        invalidTitle: "QR non reconnu",
        register: "L’inscrire",
        registering: "Inscription…",
        continueScanning: "Continuer à scanner",
        registerFull: "Événement complet : impossible d’inscrire sur place.",
        registerClosed: "Les inscriptions sont fermées.",
        registerPaymentRequired: "Cet événement est payant : la personne doit payer pour s’inscrire.",
        registerInvalid: "Impossible d’inscrire ce compte.",
      },
      offline: {
        banner: "{count, plural, one {Hors ligne — # pointage en attente} other {Hors ligne — # pointages en attente}}",
        syncing: "{count, plural, one {Synchronisation… # pointage en attente} other {Synchronisation… # pointages en attente}}",
      },
    },
    menuTitle: "Événements",
    listTitle: "Événements",
    tabs: {
      attending: "Mes inscriptions",
      organizing: "Mes événements",
      discover: "Découvrir",
    },
    myStats: {
      entry: "Mes statistiques",
      title: "Mes statistiques",
      subtitle: "Tous vos événements, cumulés.",
      events: "Événements",
      registered: "Inscrits",
      present: "Présents",
      attendanceRate: "Taux de présence",
      contactsExchanged: "Contacts échangés",
      followupsSent: "Relances envoyées",
      emailsSent: "Emails envoyés",
      collected: "Encaissé",
      commission: "Commission KeepTouch",
      net: "Net organisateur",
      curveTitle: "Contacts échangés — 7 derniers jours",
      curveEmpty: "Aucun contact échangé sur les 7 derniers jours.",
      empty: "Créez votre premier événement pour voir vos statistiques.",
    },
    discover: {
      title: "Événements publics à venir",
      searchPlaceholder: "Rechercher un événement, une ville, une catégorie",
      searchLabel: "Rechercher",
      nearMe: "Près de moi",
      allEvents: "Tous",
      radius: "{km} km",
      radiusLabel: "Rayon",
      locCoordinates: "Événements publics dans un rayon de {km} km autour de vous.",
      locCity: "Votre position précise est inconnue : nous montrons les événements de votre ville.",
      locUnknown: "Nous ne connaissons pas votre position. Activez la localisation dans « À proximité » pour voir les événements près de chez vous. En attendant, voici tous les événements publics.",
      empty: "Aucun événement public à venir.",
      emptyHint: "Revenez bientôt, ou créez le vôtre en le rendant public.",
      emptySearch: "Aucun événement ne correspond à votre recherche.",
      emptyNear: "Aucun événement public près de chez vous.",
      emptyNearHint: "Essayez un rayon plus large, ou voyez tous les événements.",
      error: "Impossible de charger les événements.",
      retry: "Réessayer",
      loadMore: "Voir plus d’événements",
      loading: "Chargement…",
      contactsGoing: "{count, plural, one {# contact y va} other {# contacts y vont}}",
      distance: "à {km} km",
      registered: "Inscrit",
      online: "En ligne",
      resultsCount: "{count, plural, one {# événement} other {# événements}}",
    },
    createButton: "Créer un événement",
    emptyAttending: "Aucune inscription pour l’instant.",
    emptyAttendingHint: "Scannez le QR code d’un événement ou ouvrez un lien d’invitation.",
    emptyOrganizing: "Aucun événement pour l’instant.",
    emptyOrganizingHint: "Créez votre premier événement pour inviter vos participants.",
    phase: {
      upcoming: "À venir",
      ongoing: "En cours",
      ended: "Terminé",
    },
    attendeesCount: "{count, plural, =0 {Aucun inscrit} one {# inscrit} other {# inscrits}}",
    attendeesCountWithCapacity: "{count} / {capacity} places",
    full: "Complet",
    registrationClosed: "Inscriptions fermées",
    organizedBy: "Organisé par {name}",
    price: {
      free: "Gratuit",
      paid: "Payant",
    },
    payment: {
      simulationBanner: "Simulation : aucun paiement réel",
      forEvent: "Paiement de votre place pour",
      pay: "Payer {amount}",
      priceLine: "Prix de la place",
      feeLine: "Frais de service KeepTouch",
      totalLine: "Total",
      simulateFailure: "Simuler un échec",
      cancel: "Annuler",
      seatHeld: "Place réservée : encore {time}",
      reservedHint: "Votre place est bloquée pour vous le temps de payer.",
      resume: "Reprendre le paiement — {price}",
      failedTitle: "Le paiement n’a pas abouti",
      failedHint: "Vous n’avez pas été débité(e) et votre place n’est pas réservée. Vous pouvez réessayer.",
      retry: "Réessayer",
      expiredTitle: "Réservation expirée",
      expiredHint: "Le délai de 15 minutes est écoulé et la place a été libérée. Recommencez pour en réserver une nouvelle.",
      backToEvent: "Retour à l’événement",
      alreadyPaid: "Ce paiement est déjà effectué.",
      notFound: "Cette page de paiement est introuvable.",
      successTitle: "Paiement reçu",
      successMessage: "Votre inscription est confirmée. À bientôt !",
    },
    access: {
      title: "Accès refusé",
      forbidden: "Vous n’avez pas accès à cet événement.",
      notFound: "Cet événement est introuvable.",
      back: "Retour",
    },
    public: {
      filterAll: "Tous",
      filterPresent: "Étaient présents",
      whoIsComing: "Qui vient ?",
      whoCame: "Les participants",
      teaserHint: "Inscrivez-vous pour voir le nom, le métier et l’entreprise des participants.",
      nobodyYet: "Aucune inscription pour l’instant.",
      moreAttendees: "+ {count} autres",
      notFound: "Cet événement est introuvable.",
      notFoundHint: "Vérifiez le lien ou le QR code.",
      manage: "Gérer l’événement",
      youOrganize: "Vous organisez cet événement",
      youAreRegistered: "Inscription confirmée",
      registeredHint: "Vous voyez les profils des autres participants et pouvez les ajouter à vos contacts dès maintenant.",
      ticketTitle: "Votre billet",
      ticketHint: "Montrez ce QR code à l’entrée.",
      viewFullScreen: "Voir mon billet en plein écran",
      leave: "Me désinscrire",
      joinOneClick: "M’inscrire en un clic",
      reserveSeat: "Réserver ma place — {price}",
      serviceFee: "dont {fee} de frais de service",
      leavePaidHint: "Vous pouvez vous désinscrire, mais aucun remboursement n’est effectué (mode test).",
      leaveConfirm: "Vous désinscrire de cet événement ?",
      leavePaidConfirm: "Aucun remboursement n’est effectué. Si vous vous réinscrivez à cet événement, votre billet payé sera réutilisé (pas de deuxième paiement) tant qu’il reste de la place.",
      leaveConfirmYes: "Oui, me désinscrire",
      leaveConfirmNo: "Rester inscrit",
      endedIntro: "L’événement est terminé : ajoutez les personnes rencontrées à votre réseau.",
      you: "Vous",
    },
    myTicket: {
      title: "Mon billet",
      presentAtDoor: "Présentez ce QR code à l’entrée",
      brightnessHint: "Augmentez la luminosité de votre écran pour faciliter le scan.",
      unavailableTitle: "Billet indisponible",
      unavailableHint: "Vous devez être en ligne pour ouvrir votre billet la première fois.",
      eventEnded: "L’événement est terminé.",
    },
    privacy: {
      title: "En vous inscrivant, vous acceptez d’apparaître dans la liste des participants.",
      before: "Dès votre inscription, les autres inscrits voient votre prénom, votre nom, votre poste, votre entreprise, votre photo et votre lien LinkedIn. Sur la page publique de l’événement, toute personne qui a le lien voit seulement votre prénom et votre photo (jusqu’au {date}).",
      after: "Les autres participants peuvent vous ajouter directement à leurs contacts, sans demande à accepter et sans que vous soyez prévenu ; le nom de l’événement est noté comme lieu de rencontre. Votre email et vos notes ne sont jamais visibles des autres participants.",
      organizer: "L’organisateur voit votre nom, votre poste, votre email et votre présence, et peut exporter la liste. Il ne voit jamais vos notes.",
      durationOne: "Ces informations sont supprimées 1 mois après l’événement. Vous pouvez vous désinscrire à tout moment.",
      durationMany: "Ces informations sont supprimées {months} mois après l’événement. Vous pouvez vous désinscrire à tout moment.",
      policy: "Charte de confidentialité",
    },
    join: {
      title: "Rejoindre l’événement",
      subtitle: "Inscrivez-vous en quelques secondes et découvrez tout de suite les autres participants.",
      linkedin: "Continuer avec LinkedIn",
      noLinkedin: "Je n’ai pas LinkedIn",
      haveAccount: "Déjà un compte KeepTouch ?",
      signIn: "Se connecter",
      firstName: "Prénom",
      lastName: "Nom",
      jobTitle: "Profession",
      company: "Entreprise (facultatif)",
      email: "Email",
      sendCode: "Recevoir mon code",
      codeSentTo: "Code envoyé à {email}",
      codeLabel: "Code à 6 chiffres",
      confirm: "Rejoindre l’événement",
      resend: "Renvoyer le code",
      changeEmail: "Modifier mes informations",
      back: "Retour",
      required: "Champ obligatoire",
      invalidEmail: "Email invalide",
      fakeTitle: "Simulation LinkedIn (mode local)",
      fakeHint: "La vraie connexion LinkedIn sera branchée quand l’application LinkedIn Developer sera créée.",
      fakeContinue: "Simuler la connexion LinkedIn",
      closed: "Les inscriptions sont fermées.",
      full: "L’événement est complet.",
      fullHeld: "Complet : des places sont en cours de réservation. Réessayez dans quelques minutes.",
      linkedinCallbackError: "La connexion LinkedIn n’a pas abouti.",
      linkedinLoading: "Connexion avec LinkedIn…",
      paidNotice: "Événement payant : {price}. Vous réglez à l’étape suivante.",
      confirmPaid: "Continuer vers le paiement",
    },
    completeProfile: {
      title: "Complétez votre profil",
      subtitle: "Ajoutez votre poste pour que les autres participants vous retrouvent.",
      linkedinUrl: "Lien de votre profil LinkedIn (facultatif)",
      save: "Enregistrer",
      later: "Plus tard",
    },
    relation: {
      add: "Ajouter",
      contact: "Dans vos contacts",
      addedTitle: "Ajouté à vos contacts",
      addedMessage: "Retrouvez-le dans l’onglet Pro de vos contacts. Lieu de rencontre : {event}",
      remove: "Retirer",
      removeTitle: "Retirer {name} de vos contacts ?",
      removeDescription: "La personne n’en sera pas informée.",
      linkedin: "LinkedIn",
      meetingPlaceNote: "Lieu de rencontre enregistré : {event}",
    },
    form: {
      createTitle: "Nouvel événement",
      editTitle: "Modifier l’événement",
      sections: {
        info: "Informations",
        dates: "Date et heure",
        place: "Lieu",
        registration: "Inscriptions",
        visibility: "Visibilité",
        ticketing: "Billetterie",
        cover: "Image de couverture",
        contact: "Contact",
      },
      name: "Nom de l’événement",
      namePlaceholder: "Ex. Afterwork Tech Paris",
      category: "Catégorie",
      description: "Description",
      descriptionPlaceholder: "Programme, public, informations pratiques…",
      descriptionCounter: "{count} / {max}",
      startsAt: "Début",
      endsAt: "Fin",
      format: "Format",
      location: "Nom du lieu",
      locationPlaceholder: "Ex. Station F",
      address: "Adresse",
      addressPlaceholder: "Ex. 5 parvis Alan Turing",
      city: "Ville",
      cityPlaceholder: "Ex. Paris",
      onlineUrl: "Lien de visioconférence",
      onlineUrlPlaceholder: "https://meet.google.com/…",
      capacity: "Nombre de places",
      capacityHint: "Laissez vide pour un nombre illimité.",
      visibility: "Visibilité",
      visibilityOptions: { private: "Privé", public: "Public" },
      visibilityHint: {
        private: "Privé : l’événement n’apparaît nulle part dans KeepTouch. Seules les personnes à qui vous envoyez le lien, le QR code ou une invitation peuvent s’inscrire.",
        public: "Public : l’événement est visible par tous les utilisateurs KeepTouch dans « Découvrir ». Idéal pour attirer de nouveaux participants. Le lien et le QR code fonctionnent toujours.",
      },
      ticketing: "Tarif",
      price: "Prix (en euros)",
      pricePreview: "Affiché : {price}",
      feeByLower: { attendee: "le participant", organizer: "l’organisateur" },
      commissionReadonly: "Frais KeepTouch : {rate} % payés par {who}.",
      commissionNone: "Aucun frais KeepTouch sur cet événement.",
      priceHint: "Entre {min} et {max}. Les invités que vous ajoutez vous-même ne paient jamais.",
      registrationClosesAt: "Date limite d’inscription",
      registrationClosesAtHint: "Facultative : par défaut 7 jours après la fin de l’événement.",
      coverUpload: "Choisir une image",
      coverDrop: "Glissez une image ici ou cliquez pour choisir",
      coverDropActive: "Déposez l’image",
      coverChange: "Changer",
      coverRemove: "Retirer",
      coverUploading: "Envoi de l’image…",
      coverUploadHint: "JPEG, PNG ou WebP, 8 Mo maximum.",
      contactEmail: "Email de contact",
      contactEmailPlaceholder: "contact@exemple.com",
      contactEmailHint: "Affiché aux participants pour vous joindre.",
      websiteUrl: "Site web ou programme",
      websiteUrlPlaceholder: "https://",
      save: "Enregistrer",
      create: "Créer l’événement",
      delete: "Supprimer l’événement",
      deleteConfirm: "Supprimer définitivement cet événement et sa liste d’inscrits ?",
      cancel: "Annuler",
      errors: {
        name: "Donnez un nom à l’événement (2 caractères minimum).",
        dates: "Indiquez une date de début et une date de fin valides.",
        order: "La fin doit être après le début.",
        capacity: "Indiquez un nombre entier entre 1 et 100 000.",
        url: "Le lien doit commencer par https://",
        email: "Indiquez une adresse email valide.",
        locationRequired: "Indiquez le nom du lieu.",
        onlineUrlRequired: "Indiquez le lien de la visioconférence.",
        deadlinePast: "La date limite d’inscription doit être dans le futur.",
        price: "Indiquez un prix entre 0,50 € et 10 000 € (ex. 25 ou 12,50).",
        coverType: "Format non pris en charge : utilisez un JPEG, PNG ou WebP.",
        coverSize: "Image trop lourde : 8 Mo maximum.",
      },
    },
    venue: {
      label: "Lieu",
      placeholder: "Rechercher un lieu ou une adresse",
      searching: "Recherche…",
      noResults: "Aucun résultat",
      unavailable: "La recherche est indisponible. Saisissez l’adresse à la main.",
      change: "Modifier",
      manual: "Saisir l’adresse manuellement",
      backToSearch: "Rechercher un lieu",
      directions: "Itinéraire",
    },
    category: {
      networking: "Networking",
      conference: "Conférence",
      workshop: "Atelier",
      meetup: "Meetup",
      trade_show: "Salon",
      seminar: "Séminaire",
      other: "Autre",
    },
    format: {
      in_person: "Sur place",
      online: "En ligne",
      hybrid: "Hybride",
    },
    details: {
      joinOnline: "Rejoindre en ligne",
      website: "Site web / programme",
      contact: "Contact",
    },
    manage: {
      back: "Mes événements",
      edit: "Modifier",
      viewPage: "Voir la page publique",
      stats: {
        registered: "Inscrits",
        present: "Présents",
        attendanceRate: "Taux de présence",
        invitations: "Invitations",
        accepted: "{count} acceptées",
        contactsExchanged: "Contacts échangés",
        followupsSent: "Relances envoyées",
        emailsSent: "Emails envoyés",
        collected: "Encaissé",
        paidCount: "{count, plural, =0 {Aucun paiement} one {# paiement} other {# paiements}}",
        commission: "Commission KeepTouch",
        net: "Net organisateur",
        netHint: "Ce que reçoit l’organisateur",
        collectedShort: "{amount} encaissés · {price}",
      },
      share: {
        title: "Partager",
        hint: "Toute personne qui a ce lien ou scanne ce QR code peut s’inscrire.",
        copy: "Copier le lien",
        copied: "Lien copié",
        downloadQr: "Télécharger le QR code",
      },
      invite: {
        title: "Inviter par email",
        hint: "Collez des adresses email (séparées par des virgules, des espaces ou des retours à la ligne).",
        placeholder: "alice@exemple.com, bob@exemple.com…",
        detected: "{count, plural, =0 {Aucune adresse détectée} one {# adresse détectée} other {# adresses détectées}}",
        fromContacts: "Choisir dans mes contacts",
        selectedContacts: "{count, plural, one {# contact sélectionné} other {# contacts sélectionnés}}",
        send: "Envoyer les invitations",
        result: "{sent, plural, =0 {Aucune invitation envoyée} one {# invitation envoyée} other {# invitations envoyées}}",
        resultRegistered: "{count} déjà inscrits",
        resultOptedOut: "{count, plural, one {# adresse ne souhaite plus recevoir d’invitations de KeepTouch : ignorée} other {# adresses ne souhaitent plus recevoir d’invitations de KeepTouch : ignorées}}",
        resultInvalid: "Adresses ignorées : {list}",
        pickTitle: "Inviter des contacts",
        pickDone: "Valider",
        history: "Invitations envoyées",
        accepted: "Acceptée",
        pending: "En attente",
      },
      reminders: {
        title: "Rappels automatiques",
        hint: "Email + notification dans l’app envoyés aux inscrits confirmés : la veille vers 10h, puis 2h avant le début.",
        enabled: "Activés",
        disabled: "Désactivés",
      },
      emailing: {
        title: "Emailing",
        hint: "Écrivez à vos participants avant ou après l’événement.",
        recipients: "Destinataires",
        recipientsAll: "Tous les inscrits ({count})",
        recipientsPresent: "Présents ({count})",
        recipientsAbsent: "Absents ({count})",
        recipientsInvited: "Invités non inscrits ({count})",
        subject: "Objet",
        subjectPlaceholder: "Programme de la soirée",
        message: "Message",
        messagePlaceholder: "Votre message aux participants…",
        alsoNotification: "Aussi en notification dans l’app",
        notificationOnly: "Notification seulement (pas d’email) — ex. changement de salle",
        preview: "Aperçu",
        previewEmpty: "Remplissez l’objet et le message pour voir l’aperçu.",
        send: "Envoyer",
        sendNotificationOnly: "Envoyer la notification",
        result: "{count, plural, =0 {Aucun destinataire} one {Envoyé à # personne} other {Envoyé à # personnes}}",
        resultNotificationOnly: "{count, plural, =0 {Aucun destinataire} one {Notification envoyée à # personne} other {Notification envoyée à # personnes}}",
        history: "Historique des envois",
        historyEmpty: "Aucun envoi pour l’instant.",
        historyNotificationBadge: "Notification",
        historyEmailBadge: "Email",
        historyTicketBadge: "Billet",
        historyAlsoNotification: "+ notification",
        historyRecipients: "{filter} · {count, plural, =0 {aucun destinataire} one {# destinataire} other {# destinataires}}",
        filter: {
          all: "Tous les inscrits",
          present: "Présents",
          absent: "Absents",
          invited: "Invités non inscrits",
          one: "Une personne",
        },
      },
      tickets: {
        title: "Billets",
        hint: "Renvoyez le billet QR (par email) à vos inscrits confirmés.",
        sendAll: "Envoyer à tous les inscrits ({count})",
        sending: "Envoi…",
        result: "{count, plural, =0 {Aucun destinataire} one {Billet envoyé à # personne} other {Billets envoyés à # personnes}}",
      },
      attendees: {
        title: "Participants",
        filterAll: "Tous",
        filterPresent: "Présents",
        filterAbsent: "Pas encore arrivés",
        export: "Exporter (CSV)",
        empty: "Aucun inscrit pour l’instant.",
        emptySearch: "Aucun participant ne correspond.",
        checkIn: "Marquer présent",
        checkedIn: "Présent",
        source: {
          linkedin: "LinkedIn",
          manual: "Formulaire",
          account: "Compte KeepTouch",
        },
        joinedOn: "Inscription le {date}",
        collected: "Total payé : {amount} · Commission KeepTouch : {commission} · Net organisateur : {net} ({count, plural, =0 {aucun paiement} one {# paiement} other {# paiements}})",
        paid: "Payé",
        unregistered: "Désinscrit (payé)",
        sendTicket: "Renvoyer le billet",
        ticketSentTitle: "Billet envoyé",
        ticketSent: "Le billet a été renvoyé par email.",
      },
    },
    toast: {
      joinedTitle: "Inscription confirmée",
      joinedMessage: "Votre place est réservée.",
      leftTitle: "Désinscription",
      leftMessage: "Vous ne participez plus à cet événement.",
      createdTitle: "Événement créé",
      createdMessage: "Partagez le lien ou le QR code pour inviter vos participants.",
      updatedTitle: "Événement modifié",
      updatedMessage: "Les changements sont enregistrés.",
      deletedTitle: "Événement supprimé",
      deletedMessage: "L’événement et ses inscriptions ont été supprimés.",
      exportedTitle: "Export téléchargé",
      profileSavedTitle: "Profil mis à jour",
      profileSavedMessage: "Les autres participants verront votre poste.",
      invitedTitle: "Invitations envoyées",
    },
    native: {
      pickDateTime: "Choisir la date et l’heure",
      pickDate: "Choisir la date",
      clearDate: "Effacer la date",
      shareQr: "Partager le QR code",
      shareMessage: "Inscrivez-vous à « {name} » : {url}",
    },
  },
} as const
